export default {
    setting: {
        language: "Basitleştirilmiş Çince",
        dialogDetermine: "Elbette",
        dreivatives: "Teslimat",
        markets: "Alıntılar",
        assets: "varlıklar",
        liquidity: "Likidite madenciliği",
        helpCentre: "Yardım Merkezi",
        announcementCenter: "Duyuru Merkezi",
        about: "hakkında",
        bulletinCentre: "Duyuru Merkezi",
        serviceAgreement: "Hizmet sözleşmesi",
        support: "Destek",
        onlineSupportCustomerService: "çevrimiçi servis",
        suggestionsAndFeedback: "Öneriler ve geri bildirimler",
        service: "Sert",
        download: "indirmek",
        coinApplication: "Coin listeleme uygulaması",
        privacyStatement: "Gizlilik bildirimi",
        trade: "sözleşme ticareti",
        standardConteact: "sözleşme",
        signOut: "oturumu Kapat",
        assetWallets: "Varlık cüzdanı",
        financeRecords: "Hesap değişikliği kayıtları",
        identification: "Kimlik doğrulama",
        personalCenter: "Kişisel Merkez",
        chooseLanguage: "Bir dil seçin",
        tips: "ipucu",
        dark: "karanlık mod",
        light: "gündüz modu",
        Hosting: "Barındırma",
        languageTitle: "dil",
        convertCurrency: "Para birimini dönüştür",
        cancel: "İptal etmek",
        aboutUs: "Hakkımızda",
        standard: "Standardın sürekliliği",
        share: "paylaşmak",
        introduce: "Platforma Giriş",
        set: "kurmak",
        changePassword: "Giriş şifresini değiştir",
        denomination: "Teklif para birimi",
        color: "Renk yapılandırması",
        code: "versiyon numarası",
        color1: "Kırmızı yükselişler ve yeşil düşüşler",
        color2: "Yeşil yükselir ve kırmızı düşer",
        setLangue: "dil ayarı",
        vip: "VIP hakları",
        vip2: "Mevcut VIP seviyesi",
        safeMenu: "Güvenlik Merkezi",
        conventional: "geleneksel",
        other: "diğer",
        quickTips: "En fazla 3 kısayol işlev düğmesi ekleyin",
        quickTransaction: "Hızlı işlem",
        safeConvenient: "Güvenli ve kullanışlı",
        timeSharing: "zaman paylaşımı",
        currentLevel: "mevcut seviye",
        levelBenefits: "%{level} düzeyinde gelir",
        teamLevel: "Takım seviyesi",
        levelLower: "%{seviye}ast",
        rules: "Kural açıklaması",
        bindWithdrawalAddress: "Para çekme adresini bağla",
        tipsBindWithdrawalAddress: "Para çekme adresinizi henüz ciltlemediniz, lütfen önce onu bağlayın",
        walletAddressFormatIncorrect: "Cüzdan adresi biçimi yanlış",
        tradeRules1: "Gelecek dönemdeki yükseliş ve düşüşleri tahmin edin. Başlangıç ​​fiyatı olarak emir anındaki fiyat, uzlaşma fiyatı olarak ise tahmin döneminin son saniyesindeki fiyat kullanılır. Uzlaşma fiyatının başlangıç ​​fiyatından yüksek olması uzlaşmanın artması anlamına gelir. fiyatın başlangıç ​​fiyatından düşük olması düşüş anlamına gelir.",
        tradeRules2: "1.sözleşme nedir",
        tradeRules3: "Bu platform, USDT tabanlı kalıcı sözleşmeler sağlar. Kullanıcılar yükselişi veya düşüşü değerlendirebilir ve dijital varlık fiyatlarının yükselişinden/düşüşünden kar elde etmek için uzun sözleşmeler satın almayı veya kısa sözleşmeler satmayı seçebilir. Kalıcı sözleşmelerin teslim tarihi yoktur ve kullanıcılar bunları sonsuza kadar elinde tutabilir.",
        tradeRules4: "2.Marj nedir",
        tradeRules5: "Sanal sözleşme pazarında kullanıcıların, sözleşmenin ifasının mali garantisi olarak sözleşme bedeline göre belirli bir oranda küçük bir miktar fon ödemesi yeterlidir ve daha sonra sözleşmenin alım satımına katılabilirler. Bu tür fonlar sanal sözleşme mevduatıdır. \nBu platformdaki sözleşmeler, ayrı hesapların ayrı marjin modelini benimser. Her para birimi bir sözleşme hesabına karşılık gelir. Farklı sözleşme para birimlerinin hesap varlıkları ve pozisyonları birbirinden bağımsızdır ve farklı sözleşme hesapları arasındaki transferler ve işlemler birbirini etkilemez. Kullanıcının sözleşme hesabı açıldıktan sonra, sözleşme hesabında tutulan tüm pozisyonların riskleri ve faydaları birlikte hesaplanacaktır.",
        tradeRules6: "3.Marj nasıl hesaplanır",
        tradeRules7: "Pozisyon marjı = sözleşme nominal değeri * açık sözleşme sayısı / kaldıraç çarpanı\ndondurulmuş marj = mevcut emirdeki başarıyla verilen tüm emirlerin ve açılış emirlerinin marjlarının toplamı\nmevcut marj = hesap bakiyesi - pozisyon marjı - dondurulmuş marj",
        tradeRules8: "4.Marj Oranı Nasıl Hesaplanır?",
        tradeRules9: "Marj oranı, kullanıcı varlık riskinin bir ölçüsüdür. \nMarj oranı = (Gerçekleşmemiş kar ve zarar + Pozisyon marjı + Kullanılabilir marj + Dondurulmuş marjin - Tasfiye ücreti) / Pozisyon marjı \nMarj oranı ne kadar küçükse, hesabın riski de o kadar yüksek olur. Teminat oranı %0'a eşit veya daha az olduğunda zorunlu tasfiye tetiklenecektir.",
        tradeRules10: "5.Tahmini zorunlu parite fiyatı nedir?",
        tradeRules11: "Tahmini zorunlu tasfiye fiyatı, yani teorik olarak zorunlu tasfiyeyi tetikleyen sistem tarafından hesaplanan fiyat, yalnızca referans amaçlıdır ve gerçek değerden bir miktar sapma gösterebilir.",
        tradeRules12: "6.Toplam hesap özsermayesi, gerçekleşmemiş kar ve zarar nedir?",
        tradeRules13: "Toplam hesap özsermayesi = hesap bakiyesi + gerçekleşmemiş kar ve zarar\nGerçekleşmemiş kar ve zarar, kullanıcının döviz sözleşmesinde halihazırda tuttuğu pozisyonun kar ve zararıdır. Gerçekleşmemiş kar ve zarar, en son işlem fiyatı değişiklikleriyle değişecektir. \nUzun pozisyonlar için gerçekleşmemiş kar ve zarar = (1/ortalama pozisyon fiyatı - 1/son işlem fiyatı) * uzun pozisyonlar için sözleşme sayısı * sözleşme nominal değeri * son işlem fiyatı \n kısa pozisyonlar için gerçekleşmemiş kar ve zarar = (1/ son işlem fiyatı - 1/ Ortalama pozisyon fiyatı) * Kısa sözleşme sayısı * Sözleşme nominal değeri * Son işlem fiyatı",
        text1: "hesap Güvenliği",
        text2: "gündüz ve gece modu",
        text3: "önbelleği temizle",
        text4: "Oturumu kapatmak istediğinizden emin misiniz?",
        text5: "Önbelleği temizlemek istediğinizden emin misiniz?",
        text6: "çoklu dil",
        text7: "Güvenliğinizi korumak için en az bir adet iki faktörlü kimlik doğrulamayı açmanızı öneririz"
    },
    login: {
        email: "",
        emailLogin: "E-posta Girişi",
        phoneLogin: "Telefonla giriş yapın",
        login: "Giriş yapmak",
        register: "kayıt olmak",
        title1: "Her zaman, her yerde yatırım yapın ve gerçek zamanlı piyasa koşullarını görüntüleyin",
        title2: "İstediğiniz zaman, istediğiniz yerde işlem yapın ve gerçek zamanlı piyasa koşullarını görüntüleyin",
        title3: "En Güvenilir Kripto Para Ticaret Platformu",
        formTitle1: "Hesap girişi",
        formTitle2: "Tekrar hoşgeldiniz! E-postanız, telefon numaranız ile giriş yapın",
        btn1: "cep telefonu",
        btn2: "Posta",
        btn3: "Giriş yapmak",
        btn4: "kayıt olmak",
        btn5: "şifreyi mi unuttun?",
        field1: "Telefon numarası",
        field2: "şifre",
        field3: "Posta",
        placeholder1: "ulus",
        placeholder2: "Lütfen telefon numarasını girin",
        placeholder3: "Lütfen şifre giriniz",
        placeholder4: "lütfen e-posta adresinizi girin",
        content12: "Lütfen telefon numarasını girin",
        content13: "Lütfen şifre giriniz",
        content14: "lütfen e-posta adresinizi girin",
        content16: "Dijital varlık finansal hizmetleri",
        loginSuccess: "giriş başarılı ",
        chooseArea: "Lütfen alan kodunu seçin",
        placeholder5: "Lütfen ülke kodunu seçin",
        placeholder6: "Şifremi Hatırla",
        placeholder7: "İndir uygulaması",
        placeholder8: "Müşteri hizmetlerine başvurun",
        placeholder9: "Ülke veya bölge seçin",
        placeholder10: "alan kodu",
        placeholder11: "Cüzdan girişi",
        placeholder12: "İşlem başarısız oldu, lütfen geçiş yapın",
        placeholder13: "cüzdan"
    },
    aboutUs: {
        aboutCoinbeadCenterTitle: "hakkında",
        aboutCoinbeadCenterDetails: "Dünyanın önde gelen blockchain varlık ticaret platformuna sahiptir ve tüm ekosistemi işletmektedir.",
        footDetails1: "günlük işlem hacmi",
        footDetails2: "işlemler/saniye",
        footDetails3: "Yardım Merkezi",
        coinbeadCenterTitle: "",
        coinbeadCenterDetails: "Dijital varlıklara yönelik dünyaca ünlü uluslararası bir web sitesidir ve temel olarak küresel kullanıcılara Bitcoin (BTC), Litecoin (LTC) ve Ethereum (ETH) gibi dijital varlıkların madeni paralarını ve türevlerini sağlar.",
        coinbeadCenterDetailsm: "GSLB, ağ sunucuları, ağ işlemleri, ağlar, çok makineli yüksek hızlı bellek ticaret motorları, soğuk cüzdanlar, akıllı çevrimdışı sıcak cüzdanlar vb. gibi ileri teknolojileri benimseyerek müşterilerimize Web cep telefonları ve PC'ler gibi birden fazla terminal sunuyoruz. Güvenli, istikrarlı ve güvenilir dijital tarife işlem hizmetleri sağlayın. Aynı zamanda, her müşteriye daha iyi hizmet sunmak için kullanıcı önerileri ve ihtiyaçlarına göre ürün ve hizmetleri geliştiriyor ve yükseltiyoruz ve yenilikçi kullanıcı deneyiminin iyileştirilmesinin sonu yok.",
        infrastructureCenterTitle: "altyapı",
        infrastructureCenterDetails: "Misyonumuz tüm blockchain ekosistemi için altyapı hizmetleri sağlamaktır.",
        freeCenterTitle: "özgür",
        freeCenterDetails: "Vizyonumuz paranın dünya çapında serbestçe akmasını sağlamaktır. Bu özgürlüğü yaymanın dünyayı daha iyi bir yer haline getirebileceğine inanıyoruz",
        futureCenterTitle: "Teknolojinin geleceğine öncülük etmek",
        futureCenterDetails: "Teknolojinin geleceğini açın",
    },
    applicationForListing: {
        title: "Madeni para listeleme uygulaması",
        projectName: "proje Adı",
        tokenName: "Belirteç adı",
        projectDescription: "Proje Açıklaması",
        contractAddress: "Sözleşme adresi",
        officialWebsite: "resmi internet sitesi",
        ContactAndEmail: "İletişim E-posta",
        ContactAndName: "Kişi adı",
        file: "Eki Yükle",
        pleaseEnter: "girin lütfen",
        enterFile: "Lütfen dosyaları yükleyin",
        upload1: "Şu anda 1 dosya seçimiyle sınırlıdır，",
        upload2: "Bu sefer ben seçtim",
        upload3: "Dosyalar，",
        upload4: "Toplam seçili",
        upload5: "Dosyalar",
    },
    public: {
        submit: "göndermek",
        copySuccessfully: "Başarıyla kopyalandı",
        copyFailed: "Kopyalama başarısız oldu",
        noDate: "Veri yok",
        submitSuccessfully: "Başarıyla gönderildi",
        goBack: "son sayfaya geri dön",
        cancel: "İptal etmek",
        home: "ön Sayfa",
        loading: "Yükleniyor...",
        confirm: "onaylamak",
        loadingFailed: "ağ anormalliği",
        nomore: "daha fazla yok",
        tryAgain: "Lütfen sayfayı yenileyin/programdan çıkın ve tekrar yükleyin!",
        hot: "Popüler alanlar",
    },
    inviteFriends: {
        inviteFriends: "Arkadaşlarınla ​​paylaş",
        freedomOfWealth: "Zenginlik birlikte özgür olsun",
        myInvitationCode: "davetiye kodum",
        clickCopy: "Kopyalamak için tıklayın",
        myInvitationLink: "Davetiye bağlantım",
        clicktoSaveTheQRCode: "QR kodunu kaydetmek için tıklayın",
        saveQRCode: "QR kodunu davet et",
        numberOfSubordinates: "Ast sayısı",
        rebateIncome: "İndirim geliri",
        people: "insanlar",
        myPromotionRevenue: "Promosyon gelirim",
        numberOfDirectSubordinates: "Doğrudan astların sayısı",
        totalNumberOfSubordinates: "Toplam ast sayısı",
        directSubordinateReturnsCommission: "Doğrudan astlar için komisyon indirimi",
        theTotalCommission: "toplam indirim",
        checkHistory: "İndirim kayıtlarını görüntüle",
        history: "Komisyon kaydı",
        theLowerAccount: "Alt hesap",
        type: "tip：",
        serviceCharge: "işlem ücreti：",
        percentageofCommissionReturned: "İndirim oranı：",
        commissionrebateAmount: "İndirim tutarı：",
        time: "zaman：",
        typeName1: "Şarj etme ve devreye alma",
        typeName2: "MT sipariş işleme ücreti üç düzeyli dağıtım",
        typeName3: "MT Kârlı Üç Seviyeli Dağıtım",
        typeName4: "Yönlendirme ödülleri",
        typeName30: "Şarj etme ve devreye alma",
        typeName31: "Periyodik ticari kar indirimi",
        typeName32: "Likidite madenciliği kar iadesi",
        typeName45: "İşlem ücreti iadesi",
        typeName46: "Kendi işlem ücreti üzerinden komisyon indirimi",
        typeName50: "Teslimat sözleşmesi işlem ücreti iadesi",
        typeName51: "Sürekli Sözleşme İşleme Ücreti İndirimi",
        typeName52: "Teslimat sözleşmesi taşıma ücretleri için ek komisyon iadesi",
        typeName53: "Kalıcı sözleşme işlem ücretleri için ek komisyon iadesi",
        typeName54: "Kalıcı sözleşme işlem ücretlerinde ek indirimler",
        shareRules1: "Davet talimatları",
        shareRules2: "Davet merkezine girin, davet bağlantısını veya kodunu kopyalayın ve arkadaşlarınızla paylaşın. Davet kodunuzla kaydolarak arkadaşlarınız astınız olabilir.",
        shareRules3: "İndirim kazanın",
        shareRules4: "Astlarınız işlem yaptığında, ilgili komisyonları alabilirsiniz ve üç seviyeye kadar astınız desteklenir. Örneğin, A arkadaşınızı, A B'yi ve B C'yi davet ederseniz, A, B ve C platformda sözleşmeler ve diğer işlemleri gerçekleştirebilir ve hepiniz ilgili komisyonları alabilirsiniz.",
        shareRules5: "Takım seviyesi",
        shareRules6: "Ne kadar çok birinci seviye astınızı terfi ettirirseniz, takım seviyesi o kadar yüksek olur ve yararlanabileceğiniz indirim de o kadar yüksek olur. Takım seviyeleri LV1-LV6 olarak bölünmüştür. Yükseltme kuralları aşağıdaki tabloda gösterilmektedir; burada 'N', yeniden şarj olan ve gerçek ad kimlik doğrulamasını tamamlayan birinci seviye astların sayısıdır.",
        shareRules7: "Astlarınız teslimat sözleşmelerine bahis koyduğunda, onların bahisleriyle orantılı olarak komisyon alabilirsiniz.",
        upgradeConditions: "Gerekmek",
        recommendedNumberOfPeople: "Önerilen kişi sayısı"
    },
    suggestionsAndFeedback: {
        suggestionsAndFeedback: "Öneriler ve geri bildirimler",
        text: "Kullanım sırasında hatalarla karşılaşırsanız veya ürün önerileriniz varsa lütfen bize geri bildirimde bulunun.",
        email: "e-posta adresi",
        enterEmail: "Lütfen e-posta adresini girin",
        enterCorrectEmail: "Lütfen doğru e-posta adresini girin",
        title: "başlık",
        enterTitle: "Lütfen bir soru başlığı girin",
        describeTheProblem: "Sorunu açıklayın",
        enterDescribeTheProblem: "Lütfen tanımladığınız sorunu girin",
        submit: "göndermek",
    },
    help: {
        enterSearch: "aramak",
        title: "Yardım Merkezi",
        search: "Lütfen sorunuzu girin",
        text1: "İhtiyaçlarınızı anlayın ve size daha uygun hizmetler sunmaya devam edin"
    },
    announcement: {
        enterSearch: "aramak",
        title: "Duyuru Merkezi",
        search: "Lütfen sorunuzu girin"
    },
    privacy: {
        title: "Gizlilik bildirimi",
        content1: "1. Kullanıcılar hakkında hangi kişisel bilgiler toplanıyor?",
        content2: "Kişisel bilgiler ürün ve hizmetlerin sağlanması ve sürekli iyileştirilmesi amacıyla toplanmaktadır.。",
        content3: "Topladığımız kişisel bilgi türleri aşağıdadır：",
        content4: 'Bize sağladığınız bilgiler: Platformla bağlantılı olarak sağladığınız her türlü bilgiyi alıyor ve saklıyoruz. Belirli bilgileri sağlamamayı seçebilirsiniz ancak bunun sonucunda belirli "bu platform hizmetlerini" kullanamayabilirsiniz. Bize sağladığınız bilgilere örnek olarak şunlar verilebilir:',
        content5: "İsim",
        content6: "adres",
        content7: "Uyruğu Olunan Ülke",
        content8: "Kimlik fotoğrafı",
        content9: "Cep telefonu numarası/e-posta numarası",
        content10: "Sizi tanımlamamıza yardımcı olacak diğer bilgiler",
        content11: "Otomatik olarak toplanan bilgiler: Platform Hizmetlerini kullanımınıza ilişkin belirli türdeki bilgileri otomatik olarak topluyor ve saklıyoruz. Birçok web sitesi gibi biz de çerezler ve diğer benzersiz tanımlayıcılar kullanıyoruz. Web tarayıcınız veya cihazınız Platforma eriştiğinde belirli türde bilgiler elde ederiz. Topladığımız ve analiz ettiğimiz bilgilerin örnekleri arasında şunlar bulunmaktadır:：",
        content12: "Kişisel bilgisayarı İnternet'e bağlayan İnternet Protokolü (IP) adresi；",
        content13: "Kişisel cihaz veya bilgisayar giriş bilgileri, e-posta adresi, şifre ve konum；",
        content14: "Sürüm ve saat dilimi ayarları；",
        content15: "işlem geçmişi。",
        content16: "Diğer Kaynaklardan Gelen Bilgiler: Kredi bürolarının kredi geçmişi gibi diğer kaynaklardan sizin hakkınızda bilgi toplayabiliriz. Bu bilgileri dolandırıcılığı önlemek ve tespit etmek için kullanacağız.",
        content17: "2. Çocuklar tarafından kullanılabilir mi?",
        content18: 'Bu platform, 18 yaşın altındaki kişilerin "Hizmetler"i kullanmasına izin vermemektedir.”。',
        content19: "3. Çerezler ve diğer tanımlayıcılar ne için kullanılır?",
        content20: "Hedeflenen iyileştirmeler yapabilmek amacıyla kullanıcı deneyimini optimize etmek, hizmetlerimizi sunmak ve müşterilerin hizmetlerimizi nasıl kullandığını anlamak için çerezler ve benzer araçlar kullanırız. Sistemimizin tarayıcınızı veya cihazınızı tanıyabilmesini ve size hizmet sunabilmesini sağlamak için çerezleri kullanırız.",
        content21: 'Aşağıdaki hizmetleri sağlamak için operasyonel çerezleri ve benzer araçları (topluca "Çerezler") kullanırız:：',
        content22: "Giriş yaptığınızda ve hizmetlerimizi kullandığınızda sizi tanımlayın。",
        content23: "Özelleştirilmiş özellikler ve hizmetler sağlayın。",
        content24: "Dolandırıcılık faaliyetlerine karşı koruma sağlayın。",
        content25: "Güvenliği artırın。",
        content26: "Tercihlerinizi (para birimi ve dil gibi) takip edin.",
        content27: "Hedeflenen iyileştirmeler yapabilmek amacıyla kullanıcıların hizmetlerimizi nasıl kullandıklarını anlamak için de çerezleri kullanırız.",
        content28: "4.Kişisel bilgilerim paylaşılacak mı?",
        content29: "Kullanıcı bilgileri işimizin önemli bir parçasıdır ve kullanıcıların kişisel bilgilerini başkalarına satmayacağız. Bu platform, kullanıcıların kişisel bilgilerini yan kuruluşları veya bağlı kuruluşlarıyla yalnızca aşağıdaki durumlarda paylaşacaktır. Bu bağlı kuruluşların veya bağlı kuruluşların bu gizlilik bildirimine uyması veya en azından bu gizlilik bildiriminde açıklanan koruma önlemleri kadar koruyucu uygulamaları izlemesi gerekmektedir.",
        content30: "Üçüncü Taraf Hizmet Sağlayıcıları: Bizim adımıza işlevleri yerine getirmeleri için başka şirket ve bireyleri görevlendiriyoruz. Bu tür işlevlere örnek olarak şunlar verilebilir: verilerin analiz edilmesi, pazarlama yardımı sağlanması, ödemelerin işlenmesi, içerik iletilmesi ve kredi riskinin değerlendirilmesi ve yönetilmesi. Bu üçüncü taraf hizmet sağlayıcıları, işlevlerini yerine getirmek için gereken kişisel bilgilere erişebilir ancak bunları başka amaçlarla kullanamazlar. Ayrıca kişisel bilgileri bu gizlilik bildirimine ve geçerli veri koruma yasalarına uygun şekilde işlemelidirler.",
        content31: "İş Transferleri: İşimiz büyümeye devam ettikçe diğer işletmeleri veya hizmetleri satabilir veya satın alabiliriz. Bu tür işlemlerde, kullanıcı bilgileri genellikle devredilen iş varlıkları arasındadır ancak önceden var olan herhangi bir gizlilik beyanındaki vaatlere tabi olmaya devam eder (tabii ki kullanıcı aksini kabul etmedikçe). Ayrıca Şirketimizin veya varlıklarının tamamına yakınının satın alınması durumunda kullanıcı bilgileri de devredilecektir. Şirketimizin ve Başkalarının Korunması: Hesap vermenin ve diğer kişisel bilgilerin yasalara veya düzenleyici yükümlülüklerimize uymak için uygun olduğuna inandığımızda, Kullanım Koşullarımızı ve diğer sözleşmeleri ya da şirketimizin haklarını, mülkiyetini veya güvenliğini uygulamak veya uygulamak kullanıcılar veya diğerleri Ne zaman hesabı ve diğer kişisel bilgileri açıklayacağız. Buna dolandırıcılığa karşı koruma sağlamak ve kredi riskini azaltmak için diğer şirket ve kuruluşlarla bilgi alışverişi de dahildir.",
        content32: "5. Kişisel verilerin uluslararası aktarımı",
        content33: 'Verilerinizi Avrupa Ekonomik Alanı ("AEA") dışına aktarabiliriz. Avrupa Komisyonu, verilerin aktarıldığı ülkenin yeterli düzeyde koruma sağladığını doğrulamadığı sürece, bu tür aktarımların geçerli veri koruma kurallarına uygun olmasını sağlamak için uygun önlemleri uygulayacağız.',
        content34: "6. Kişisel bilgilerim güvende mi?",
        content35: "Sistemlerimizi güvenliğinizi ve gizliliğinizi göz önünde bulundurarak tasarladık. Aktarım sırasında kişisel bilgilerin güvenliğini korumaya çalışmak için şifreleme protokolleri ve yazılımları kullanıyoruz.",
        content36: "Kişisel bilgileri toplarken, saklarken ve ifşa ederken her zaman fiziksel, elektronik ve prosedürle ilgili önlemleri alırız. Güvenlik prosedürlerimiz, kişisel bilgilerinizi size açıklamadan önce kimliğinizi doğrulamamız gerekebileceği anlamına gelir.",
        content37: "Yapabileceğiniz en önemli şey, kişisel hesap şifrelerinizi yetkisiz erişime karşı korumaktır. Hesabınız için diğer çevrimiçi hesaplardan farklı, benzersiz bir şifre belirlemenizi öneririz. Paylaşılan bir bilgisayarı kullandıktan sonra oturumu kapattığınızdan emin olun.",
        content38: "7.Kişisel bilgileri nasıl korumalıyım?",
        content39: "Kişisel bilgileri toplama ve işleme şeklimizle ilgili herhangi bir sorunuz veya itirazınız varsa lütfen müşteri hizmetleri personeliyle iletişime geçin.",
        content40: "Kişisel bilgilerinizi belirli bir amaç için işlememizi kabul ettikten sonra, niyetinizi istediğiniz zaman geri çekebilirsiniz ve biz de verilerinizi bu amaç için işlemeyi durdururuz.",
        content41: "Ayrıca, yürürlükteki yasalara tabi olarak, kişisel verilere erişim, bunların düzeltilmesini ve silinmesini talep etme ve veri taşınabilirliğini talep etme hakkına da sahipsiniz. Ayrıca kişisel verilerinizi işlememize itiraz edebilir veya belirli durumlarda kişisel verilerinizi işlememizin kısıtlanmasını talep edebilirsiniz.",
        content42: "8. AB GDPR ve Birleşik Krallık Veri Koruma Kanunu – Yasal Dayanak",
        content43: "AB GDPR ve Birleşik Krallık veri koruma kanunu, kişisel bilgileri kullanırken yasal dayanaklara uymamızı gerektirmektedir. Temelimiz, kişisel bilgilerin kullanıldığı belirli amaçlara bağlıdır. Bu bazlar şunları içerir:：",
        content44: "Bir sözleşmenin yerine getirilmesi - siparişleri kabul etmek ve işleme koymak ve ödemeleri işleme koymak için kişisel bilgilerinizi kullanmamız da dahil olmak üzere, ürünler veya hizmetler sağlamak veya sizinle bunlar hakkında iletişim kurmak.",
        content45: "Meşru ticari çıkarlarımız ve kullanıcı çıkarlarımız - Kullanıcılarımızın, kendimizin veya başkalarının güvenliğini korumak için dolandırıcılığı ve kötüye kullanımı tespit edip önleriz.",
        content46: "İzniniz – Kişisel bilgilerinizi size iletilen belirli amaçlar doğrultusunda işlemek için izninize ihtiyacımız var. Kişisel bilgilerinizin belirli bir amaç için işlenmesine ilişkin onayınızı bize verdikten sonra, onayınızı istediğiniz zaman geri çekebilirsiniz ve verilerinizi bu amaç için işlemeyi durduracağız.",
        content47: "Yasal yükümlülüklere uyun - Kişisel bilgilerinizi yasaların gerektirdiği şekilde kullanırız. Örneğin, kimlik doğrulama amacıyla banka hesabı bilgilerini topluyoruz.",
        content48: "Yukarıdaki ve diğer yasal dayanaklar, kişisel bilgileri kullandığımız belirli amaçlara bağlıdır.",
        content49: "9. Kullanım koşulları, bildirimler ve değişiklikler",
        content50: "Kullanımınız ve gizlilikle ilgili herhangi bir anlaşmazlık bu Bildirime ve Kullanım Koşullarımıza tabidir. Bu platformun gizliliğiyle ilgili herhangi bir endişeniz varsa lütfen ayrıntılı bir açıklama ile bizimle iletişime geçin; sorununuzu çözmekten memnuniyet duyarız. Ayrıca yerel veri koruma yetkilinizle iletişime geçme hakkına da sahipsiniz.",
        content51: "İşimiz sürekli değişiyor ve gizlilik bildirimimiz de değişecek. En son değişiklikleri görmek için web sitemizi sık sık kontrol etmelisiniz. Revize edilen içeriği kabul etmiyorsanız erişimi derhal durdurmalısınız. Gizlilik Politikasının güncellenmiş sürümü yayınlandıktan sonra erişiminizin devam etmesi, güncellenen içeriği kabul ettiğiniz ve güncellenen Gizlilik Politikasına uymayı kabul ettiğiniz anlamına gelir. Aksi belirtilmediği sürece mevcut Gizlilik Bildirimi, siz ve hesabınız hakkında tuttuğumuz tüm bilgiler için geçerlidir.",
    },
    serviceAgreement: {
        title: "Hizmet sözleşmesi",
        content1: 'Bu web sitesi, özellikle kullanıcıların dijital varlık işlemleri yapmasına ve ilgili hizmetleri (bundan sonra "hizmet" veya "hizmet" olarak anılacaktır) sağlamasına yönelik bir platformdur. Bu sözleşmeyi açıklamanın kolaylığı açısından, bu web sitesi toplu olarak bu sözleşmede "biz" veya diğer birinci şahıs zamirlerini kullanır. Siteye giriş yapan gerçek kişi veya diğer kişi bu sitenin kullanıcısı olduğu sürece, işbu sözleşmenin ifade edilmesinde kolaylık sağlamak amacıyla aşağıda "siz" veya diğer ikinci kişi kullanılacaktır. Bu Sözleşmenin sunumunun kolaylığı açısından, biz ve siz bu Sözleşmede toplu olarak "Taraflar" olarak anılırız ve biz veya siz ayrı ayrı "Taraf" olarak anılırız.”。',
        content2: "önemli ipucu：",
        content3: "Burada şunu hatırlatmak isteriz：",
        content4: "1 Dijital varlıkların kendisi herhangi bir finansal kurum veya şirket ya da bu web sitesi tarafından verilmemektedir.",
        content5: "2Dijital varlık piyasaları yenidir, doğrulanmamıştır ve büyümeyebilir；",
        content6: "3 Dijital varlıklar ağırlıklı olarak spekülatörler tarafından yaygın olarak kullanılmakta olup, perakende ve ticari piyasalarda nispeten daha az kullanılmaktadır. Dijital varlık işlemleri son derece riskli olup, gün boyunca herhangi bir yükseliş ve düşüş sınırı olmadan işlem görmektedir ve fiyatlar piyasadan kolaylıkla etkilenmektedir. Yapımcılar ve küresel hükümet politikaları.；",
        content7: "4  Şirket, tamamen kendi takdirine bağlı olarak bu Sözleşmeyi ihlal ettiğinizi veya bu web sitesi tarafından sağlanan hizmetlerin veya bu web sitesi tarafından sağlanan hizmetleri kullanımınızın ihlal edildiğini tespit ederse, herhangi bir zamanda hesabınızı askıya alma veya sonlandırma hakkını saklı tutar. yargı bölgenizdeki yasalara göre yasa dışı olabilir veya bu web sitesi tarafından sağlanan hizmetleri veya dijital varlık işlemlerini kullanımınızı askıya alabilir veya sonlandırabilirsiniz. [Çin Anakarası, Tayvan, İsrail, Irak, Bangladeş, Bolivya, Ekvador, Kırgızistan, Sevastopol ve Birleşik Krallık'tan (perakende kullanıcılar)] herkesin bu web sitesi tarafından sağlanan sözleşme işlem hizmetlerini kullanması yasaktır. Yukarıda belirtilen ülke veya bölge listesi, farklı ülke veya bölgelerin politikalarına ve ürün türlerine bağlı olarak değişecektir. Sizi o anda özel olarak bilgilendiremeyebiliriz; bu nedenle, lütfen bu sözleşmedeki güncellemeleri zamanında yapmaya dikkat edin.",
        content8: "Dijital varlık ticareti son derece yüksek riskler taşır ve çoğu insan için uygun değildir. Bu işlemin kısmen veya tamamen zararla sonuçlanabileceğini anlıyor ve anlıyorsunuz, bu nedenle işlemin tutarını karşılayabileceğiniz zararın derecesine göre belirlemelisiniz. Dijital varlıkların türev riskler oluşturacağını biliyor ve anlıyorsunuz; dolayısıyla herhangi bir sorunuz varsa öncelikle profesyonel danışmanların yardımına başvurmanız önerilir. Ayrıca yukarıda sayılan risklerin yanı sıra öngörülemeyen riskler de bulunacaktır. Dijital varlıkları satın alma veya satma kararı vermeden önce mali durumunuzu ve yukarıda belirtilen riskleri dikkatlice değerlendirmeli ve net bir muhakeme kullanmalısınız ve bunun sonucunda ortaya çıkan tüm zararları üstlenmiyoruz.",
        content9: "Size uyarı：",
        content10: "1 Bu web sitesinin yalnızca dijital varlık bilgilerini elde edeceğiniz, işlem taraflarını bulacağınız, pazarlık yapacağınız ve dijital varlıklar üzerinde işlem gerçekleştireceğiniz bir yer olarak kullanıldığını anlıyorsunuz, bu nedenle kendi sağduyulu kararınızı kullanmalısınız. ilgili dijital varlıkları ve/veya işlemleri veya bilgilerin gerçekliğini, yasallığını ve geçerliliğini tespit edecek ve bundan kaynaklanan sorumlulukları ve kayıpları kendisi üstlenecektir.",
        content11: "2 Bu sitede yer alan her türlü görüş, haber, tartışma, analiz, fiyat, tavsiye ve diğer bilgiler genel piyasa yorumları olup, yatırım tavsiyesi niteliği taşımaz. Kâr kaybı dahil ancak bununla sınırlı olmamak üzere, doğrudan veya dolaylı olarak bu bilgilere güvenilmesinden kaynaklanan hiçbir kayıptan sorumlu değiliz.",
        content12: "3 Bu web sitesi, herhangi bir zamanda kendi kararını verme, içeriği değiştirme veya değiştirme hakkını saklı tutar. Web sitesindeki bilgilerin doğruluğunu sağlamak için makul önlemler aldık, ancak doğruluğunu garanti edemeyiz ve bundan sorumlu olmayacağız. bu web sitesinde yer alan bilgilerin neden olduğu herhangi bir kayıp veya hasar veya bilgi eksikliğinden, internete bağlanmada, herhangi bir bildirim ve bilginin iletilmesinde veya alınmasında yaşanan gecikmeler veya başarısızlıklardan kaynaklanan doğrudan veya dolaylı kayıplar.",
        content13: "4 İnternet tabanlı ticaret sistemlerini kullanmanın yazılım, donanım ve İnternet bağlantısı arızaları dahil ancak bunlarla sınırlı olmamak üzere riskleri de vardır. İnternetin güvenilirliği ve kullanılabilirliği üzerinde hiçbir kontrolümüz olmadığından, bozulma, gecikmeler ve bağlantı arızalarından dolayı hiçbir sorumluluk kabul etmiyoruz.",
        content14: "5 Bu web sitesinin tüm yasa dışı ticaret faaliyetlerinde veya kara para aklama, kaçakçılık, ticari rüşvet vb. gibi yasa dışı faaliyetlerde bulunmak amacıyla kullanılması yasaktır. Herhangi bir yasa dışı işlem veya yasa dışı faaliyetten şüphelenilmesi durumunda, bu web sitesi aşağıdakiler de dahil olmak üzere çeşitli mevcut araçları kullanacaktır: ancak hesapların dondurulması ve ilgili makamlara bildirimde bulunulması vb. ile sınırlı olmamak üzere, bundan doğacak her türlü sorumluluğu üstlenmiyor ve ilgili kişilerden mesuliyet talep etme hakkını saklı tutuyoruz.",
        content15: "6 Bu sitenin piyasayı kötü niyetli olarak manipüle etmek, uygunsuz işlemler ve diğer etik olmayan ticari faaliyetlerde bulunmak amacıyla kullanılması yasaktır. Bu tür olayların tespit edilmesi durumunda, bu site uyarıda bulunacak, işlemleri kısıtlayacak ve kötü niyetli fiyat manipülasyonu ve kötü niyetli etki yaratma gibi tüm etik olmayan davranışları kapatacaktır. Ticaret sistemi, hesabın askıya alınması gibi önleyici koruma tedbirlerinden kaynaklanan her türlü sorumluluğu üstlenmiyor ve ilgili kişilerden sorumluluk talep etme hakkını saklı tutuyor.",
        content16: "1. Genel ilkeler",
        content17: '1.1 "Kullanıcı Sözleşmesi" (bundan böyle "bu Sözleşme" veya "Bu Hüküm ve Koşullar" olarak anılacaktır), ana metin olan "Gizlilik Koşulları", "Müşterinizi Tanıyın ve Kara Para Aklamayı Önleme Politikası" ve bu sözleşmeyi düzenleyen diğer çeşitli politikalardan oluşur. Bu web sitesinde yayınlanmış veya gelecekte yayınlanabilecek.',
        content18: "1.2 Bu web sitesinin sunduğu hizmetleri kullanmadan önce bu sözleşmeyi dikkatlice okumalısınız. Eğer herhangi bir şeyi anlamadıysanız veya başka bir şekilde gerekliyse, lütfen profesyonel bir avukata danışın. Bu Sözleşmeyi ve/veya değiştirilmesini herhangi bir zamanda kabul etmiyorsanız, lütfen bu web sitesi tarafından sağlanan hizmetleri kullanmayı derhal bırakın veya bu web sitesinde artık oturum açmayın. Bu web sitesinde oturum açtığınızda, bu web sitesindeki herhangi bir hizmeti kullandığınızda veya diğer benzer davranışlarda bulunduğunuzda, bu, bu web sitesi tarafından bu Sözleşmede herhangi bir zamanda yapılan değişiklikler de dahil olmak üzere, bu Sözleşmenin içeriğini anladığınız ve tamamen kabul ettiğiniz anlamına gelir.",
        content19: '1.3 Kayıt sırasında "Kabul Ediyorum" butonuna tıklayarak, bu sitenin gereklilikleri doğrultusunda ilgili bilgileri doldurup, ilgili diğer prosedürlerin ardından başarılı bir şekilde kayıt yaptırarak bu siteye üye (bundan sonra "üye" olarak anılacaktır) olabilirsiniz. Bu web sitesini kullanırken veya bu web sitesinin sağladığı hizmetleri bu web sitesinin izin verdiği diğer şekillerde kullandığınızda, şirketle elektronik olarak bir anlaşma formu imzalarsınız; Bu, bu Sözleşme kapsamındaki tüm şartları tam olarak anladığınız, kabul ettiğiniz ve kabul ettiğiniz anlamına gelir. El yazısıyla imzanızın olmaması, bu Sözleşmenin sizin için yasal bağlayıcılığını etkilemeyecektir.',
        content20: "1.4 Bu siteye üye olduktan sonra, tarafınızca saklanacak bir üye hesabı ve buna ait şifre alacaksınız; hesabınız altında gerçekleştirilen tüm faaliyet ve etkinliklerden yasal olarak siz sorumlu olacaksınız.",
        content21: "1.5 Yalnızca bu web sitesine üye olan üyeler, bu web sitesi tarafından sağlanan dijital varlık alım satım platformunu işlemler için kullanabilir ve yalnızca üye olmayanların yararlanabileceği bu web sitesi tarafından öngörülen diğer hizmetlerden yararlanabilir; yalnızca web sitesine giriş yapabilir, web sitesinde gezinebilir; ve bu web sitesi hizmetleri tarafından öngörülen diğer hizmetler.",
        content22: "1.6 Bu web sitesi tarafından sağlanan herhangi bir hizmet ve işleve kaydolduğunuzda ve bunları kullandığınızda, okuduğunuz, anladığınız ve：",
        content23: "1.6.1 Bu Sözleşmenin tüm hüküm ve koşullarını kabul edin。",
        content24: "1.6.2 18 yaşın üzerinde olduğunuzu veya geçerli farklı yasalara göre sözleşme akdetmek için yasal yaşta olduğunuzu onaylıyorsunuz. Bu web sitesine kaydolmanız, satışlarınız veya satın almalarınız, bilgi yayınlamanız vb. ve bu web sitesindeki hizmetleri kabul etmeniz buna uygun olmalıdır. Egemen bir ülke veya bölgenin ilgili yasa ve düzenlemeleri üzerinde yargı yetkisine sahip olun ve bu koşulları kabul etme, işlem yapma ve dijital varlık işlemlerini yürütmek için bu web sitesini kullanma yetkisine sahip olun.",
        content25: "1.6.3 İşlemde yer alan ve size ait olan tüm dijital varlıkların yasal olarak elde edildiğini ve mülkiyetine sahip olduğunu garanti edersiniz.。",
        content26: "1.6.4 Kendi ticari veya ticari olmayan faaliyetlerinizden ve her türlü kazanç veya kayıptan yalnızca kendinizin sorumlu olduğunu kabul edersiniz.。",
        content27: "1.6.5 Kayıt olurken verdiğiniz bilgilerin doğru ve doğru olduğunu onaylıyorsunuz。",
        content28: "1.6.6 Ticari karların raporlanması da dahil olmak üzere, vergi amaçları da dahil olmak üzere ilgili her türlü yasanın gerekliliklerine uymayı kabul edersiniz.",
        content29: "1.6.7 Bu web sitesi tarafından sağlanan hizmetlerle ilgili olsun veya olmasın, hiçbir zaman bu web sitesinin veya şirketin çıkarlarına zarar veren davranış veya faaliyetlerde bulunmamayı veya bunlara katılmamayı kabul edersiniz.",
        content30: "1.6.8 Bu sözleşme yalnızca sizinle bizim aramızdaki hak ve yükümlülükleri düzenler ve bu web sitesinin ve diğer web sitelerinin kullanıcıları ile sizin aranızdaki dijital varlık işlemlerinden kaynaklanan hukuki ilişkileri ve hukuki anlaşmazlıkları kapsamaz.",
        content31: "2. Anlaşma değişiklikleri",
        content32: "Bu Sözleşmeyi zaman zaman revize etme ve size ayrıca bildirimde bulunmaksızın web sitesinde duyurma hakkını saklı tutuyoruz. Revizyondan sonra, revizyon zamanı bu Sözleşmede görüntülenen [Son Güncelleme Zamanı] üzerinde işaretlenecek ve otomatik olarak gerçekleşecektir. web sitesinde yayınlandıktan sonra yürürlüğe girer. Zaman zaman bu Sözleşmenin güncelleme zamanına ve güncellenen içeriğine göz atmalı ve bunlara dikkat etmelisiniz. İlgili değişiklikleri kabul etmiyorsanız, bu web sitesinin hizmetlerini kullanmaya devam ettiğinizi derhal bırakmalısınız; web sitesi, revize edilen sözleşmeyi kabul ettiğiniz ve bunlara bağlı kalmayı kabul ettiğiniz anlamına gelir.",
        content33: "3. Kayıt",
        content34: "3.1 Kayıt nitelikleri",
        content35: "Kayıt işlemini tamamladığınızda veya bu web sitesi tarafından sağlanan hizmetleri bu web sitesi tarafından izin verilen diğer şekillerde fiilen kullandığınızda, bu sözleşmeyi imzalama ve bu web sitesinin hizmetlerini yürürlükteki yasaların öngördüğü şekilde kullanma olanağına sahip olmanız gerektiğini onaylıyor ve taahhüt ediyorsunuz. gerçek kişi, tüzel kişi veya başka bir kuruluş. Kaydolmayı Kabul Et düğmesini tıklattığınızda, bu sizin veya yetkili temsilcinizin sözleşmenin içeriğini kabul ettiğiniz ve bu web sitesinin hizmetlerini temsilcisi tarafından kaydettirdiğiniz ve kullandığınız anlamına gelir. Yukarıda belirtilen niteliklere sahip değilseniz, bundan doğacak tüm sonuçlara siz ve yetkili acenteniz katlanacak olup, şirket hesabınızı iptal etme veya kalıcı olarak dondurma ve sizi ve yetkili acentenizi sorumlu tutma hakkını saklı tutar.",
        content36: "3.2 Kayıt amacı",
        content37: "Bu web sitesine kaydınızın yasa ve yönetmelikleri ihlal etme veya bu web sitesindeki dijital varlık işlemlerinin düzenini bozma amacı taşımadığını onaylıyor ve taahhüt ediyorsunuz.",
        content38: "3.3Kayıt süreci",
        content39: "3.3.1 Bu web sitesinin kullanıcı kayıt sayfasında gerekli olan geçerli bir e-posta adresi, cep telefonu numarası ve diğer bilgileri sağlamayı kabul edersiniz. Sağladığınız veya onayladığınız e-posta adresini, cep telefonu numarasını veya bu web sitesi tarafından izin verilen diğer yöntemleri giriş olarak kullanabilirsiniz. Bu web sitesine girme yöntemi. Gerekirse, farklı yargı bölgelerinin ilgili yasa ve yönetmelikleri uyarınca, gerçek adınızı, kimlik belgenizi ve yasa ve yönetmeliklerde, gizlilik hükümlerinde ve kara para aklamayı önleme hükümlerinde öngörülen diğer ilgili bilgileri sağlamalı ve kayıt bilgilerinizi sürekli olarak güncellemelisiniz. zamanında, ayrıntılı ve doğru bir şekilde yapılmasını gerektirir. Orijinal olarak yazılan tüm bilgilere kayıt bilgileri olarak atıfta bulunulacaktır. Bu tür bilgilerin gerçekliğinden, eksiksizliğinden ve doğruluğundan siz sorumlusunuz ve bundan kaynaklanan doğrudan veya dolaylı tüm zararları ve olumsuz sonuçları üstleneceksiniz.",
        content40: "3.3.2 Bulunduğunuz egemen ülke veya bölgenin kanunları, düzenlemeleri, kuralları, emirleri ve diğer düzenlemelerinde cep telefonu numaraları için gerçek ad gereklilikleri varsa, sağlanan kayıtlı cep telefonu numarasının gerçek adla kaydedildiğini kabul edersiniz. mevzuata uygun olarak sağlamamanız halinde, tarafınıza verilecek her türlü sonuç Doğrudan veya dolaylı zararlar doğuracak ve olumsuz sonuçlar tarafınıza ait olacaktır.",
        content41: "3.3.3 Kayıt için gerekli bilgileri yasal, eksiksiz ve etkin bir şekilde sağladığınız ve doğruladığınız takdirde, bu siteye ait hesap numarası ve şifreyi almaya hak kazanmış olursunuz. Bu siteye ait hesap numarası ve şifreyi aldığınızda, kaydınız tamamlanmış sayılacaktır. Başarılı ve bu web sitesine üye olarak giriş yapabilirsiniz.",
        content42: "3.3.4 Bu web sitesinin yönetimi ve işletilmesiyle ilgili olarak bu web sitesi tarafından gönderilen e-postaları ve/veya kısa mesajları almayı kabul edersiniz.",
        content43: "4. Hizmet",
        content44: "Bu web sitesi, yalnızca bu web sitesi aracılığıyla dijital varlık ticareti faaliyetleriniz için (dijital varlık ticareti ve diğer hizmetler dahil ancak bunlarla sınırlı olmamak üzere) çevrimiçi ticaret platformu hizmetleri sağlar.",
        content45: "4.1 Hizmet İçeriği",
        content46: "4.1.1 Hizmet İçeriği: Bu web sitesinde çeşitli dijital varlık ürünlerinin gerçek zamanlı piyasa koşullarına ve işlem bilgilerine göz atma hakkına sahip olduğunuz gibi, bu web sitesi aracılığıyla dijital varlık işlem talimatlarını gönderme ve dijital varlık işlemlerini tamamlama hakkına da sahipsiniz.",
        content47: "4.1.2 Bu web sitesindeki üyelik hesabınızda yer alan bilgileri görüntüleme ve bu web sitesinin sağladığı fonksiyonları çalıştırmak için uygulama hakkına sahipsiniz.",
        content48: "4.1.3 Bu sitede yayınlanan etkinlik kurallarına uygun olarak bu site tarafından düzenlenen site etkinliklerine katılma hakkına sahipsiniz.",
        content49: "4.1.4 Bu web sitesinin size sağlamayı vaat ettiği diğer hizmetler。",
        content50: "4.2 Hizmet Kuralları Bu web sitesinin aşağıdaki hizmet kurallarına uyacağıma söz veriyorsunuz:",
        content51: "4.2.1 Yasalara, düzenlemelere ve politika gerekliliklerine uyacak, hesabınızdaki tüm dijital varlıkların kaynaklarının yasallığını sağlayacak ve bu web sitesinin veya bu web sitesindeki üçüncü tarafların hak ve çıkarlarına zarar veren yasa dışı veya diğer faaliyetlerde bulunmayacaksınız. veya hizmetlerini kullanarak, aşağıdakiler dahil ancak bunlarla sınırlı olmamak üzere: Yasadışı, yasa dışı veya başkalarının haklarını ihlal eden bilgiler göndermek veya almak, piramit şemaları veya diğer zararlı bilgi veya açıklamalar göndermek veya almak, e-posta kullanmak veya sahtekarlık yapmakla sınırlı değilsiniz. Bu web sitesindeki başlık bilgileri, bu web sitesinden izin alınmadan vb.",
        content52: "4.2.2 Yasa ve yönetmeliklere uymalı, hesap numaranızı, giriş şifrenizi, fon şifrenizi, kayıt olurken size bağlı olan cep telefonu numaranızı ve cep telefonunuza gelen cep telefonu doğrulama kodunu doğru kullanmanız ve saklamanız gerekmektedir. Hesabınızın ve giriş şifrenizin, fon şifrenizin ve cep telefonu doğrulama kodunuzun kullanımına ilişkin her türlü işlem ve sonuçların sorumluluğu tamamen size aittir. Bu web sitesinin hesap numarasının, giriş şifresinin veya fon şifresinin veya doğrulama kodunun üçüncü bir tarafça izniniz olmadan kullanıldığını veya başka hesap güvenliği sorunları olduğunu tespit ettiğinizde, bu web sitesini derhal ve etkili bir şekilde bilgilendirmeli ve bu web sitesinin askıya alınmasını talep etmelisiniz. Bu web sitesinin hesabının hizmeti. Bu web sitesi, talebiniz üzerine makul bir süre içerisinde işlem yapma hakkına sahiptir, ancak bu web sitesi, işlem yapmadan önce meydana gelen sonuçlardan (karşılaştığınız kayıplar dahil ancak bunlarla sınırlı olmamak üzere) herhangi bir sorumluluk kabul etmez. Bu web sitesindeki hesabınızı, bu web sitesinin izni olmadan başkalarına bağışlayamaz, ödünç alamaz, kiralayamaz, devredemez veya başka bir şekilde elden çıkaramazsınız.",
        content53: "4.2.3 Bu web sitesinde hesabınız ve şifreniz altında gerçekleşen tüm faaliyetlerden (bilgilerin açıklanması, bilgilerin yayınlanması, çeşitli kural ve anlaşmaların kabul edilmesi veya sunulması için çevrimiçi tıklamalar, sözleşmelerin çevrimiçi olarak yenilenmesi veya satın alınması dahil ancak bunlarla sınırlı olmamak üzere) sorumlu olduğunuzu kabul edersiniz. hizmetler vb.).",
        content54: "4.2.4 Bu web sitesinde dijital varlık işlemleri gerçekleştirirken, dijital varlık işlemlerinin normal ilerlemesine kötü niyetle müdahale etmemeli veya işlemlerin sırasını bozmamalısınız; bu web sitesinin normal işleyişine müdahale etmemeli veya diğer kullanıcıların bu web sitesini kullanmasına müdahale etmemelisiniz; hizmetleri herhangi bir teknik araçla veya başka yollarla kullanmamalısınız; gerçekler ve diğer yollarla bu web sitesinin iyi niyetini kötü niyetle karalamamalısınız.",
        content55: "4.2.5Çevrimiçi işlemlerden dolayı diğer kullanıcılarla bir anlaşmazlığınız varsa, bu web sitesinden ilgili bilgilerin adli veya idari olmayan kanallar aracılığıyla sağlanmasını talep edemezsiniz.",
        content56: "4.2.6 Bu web sitesi tarafından sağlanan hizmetleri kullanımınız sırasında ortaya çıkan tüm donanım, yazılım, hizmet ve diğer masrafların yanı sıra ödenecek her türlü vergiyi yalnızca siz yargılayacak ve üstleneceksiniz.",
        content57: "4.2.7 Bu sözleşmeye ve bu web sitesi tarafından zaman zaman yayınlanan ve güncellenen diğer hizmet şartlarına ve işletim kurallarına uymanız ve bu web sitesi tarafından sağlanan hizmetlerin kullanımını istediğiniz zaman sonlandırma hakkına sahip olmanız gerekir.。",
        content58: "4.3 ürün kuralları",
        content59: "4.3.1 İşlem bilgilerine göz atın",
        content60: "Bu web sitesindeki işlem bilgilerine göz attığınızda, fiyat, komisyon hacmi, işlem ücreti, alım veya satım talimatı dahil ancak bunlarla sınırlı olmamak üzere işlem bilgilerinde yer alan tüm içeriği dikkatlice okumalı ve ancak burada yer alan tüm içeriği tam olarak kabul ettikten sonra okumalısınız. işlem bilgileri İşlemler tek tuşla yapılabilir.",
        content61: "4.3.2 İşlem ayrıntılarını görüntüle",
        content62: "İlgili işlem kayıtlarını hesabınız üzerinden görüntüleyebilirsiniz。",
        content63: "5. Bu web sitesinin hakları ve yükümlülükleri",
        content64: "5.1 Bu sözleşmede belirtilen kayıt niteliklerine sahip değilseniz, bu web sitesi kaydınızı reddetme hakkına sahiptir. Halihazırda kayıt yaptırmış olanlar için bu web sitesi, üyelik hesabınızı iptal etme hakkına sahiptir. yetkili temsilciniz sorumludur. Aynı zamanda bu web sitesi, başka koşullar altında kaydınızı kabul edip etmemeye karar verme hakkını saklı tutar.",
        content65: "5.2 Bu web sitesinin kendi kararına dayanarak, eğer bu web sitesi sizin veya ilişkili hesap kullanıcılarınızın yüksek riskli yatırımlar için uygun olmadığını tespit ederse, hesabınızı ve tüm ilişkili hesapların kullanımını askıya alma veya sonlandırma hakkına sahibiz.",
        content66: "5.3 Bu web sitesi, hesap kullanıcısının, hesabı ilk kaydeden kişi olmadığını tespit ederse, hesabın kullanımını askıya alma veya sonlandırma hakkına sahiptir.",
        content67: "5.4 Bu web sitesi, teknik testler, manuel örnekleme ve diğer test yöntemleri yoluyla sağladığınız bilgilerin yanlış, gerçek dışı, geçersiz veya eksik olduğundan makul ölçüde şüphelendiğinde, bilgileri düzeltmeniz veya güncellemeniz için size bildirimde bulunma veya bu bilgilerin sağlanmasını askıya alma veya sonlandırma hakkına sahiptir. bu web sitesi size hizmet vermektedir.",
        content68: "5.5 Bu web sitesi, bariz bir hata olduğunun tespit edilmesi halinde, bu web sitesinde görüntülenen herhangi bir bilgiyi düzeltme hakkını saklı tutar.",
        content69: "5.6 Bu web sitesi, bu web sitesinin hizmetlerini herhangi bir zamanda değiştirme, askıya alma veya sonlandırma hakkını saklı tutar. Bu web sitesinin, bu web sitesinin bir veya daha fazla hizmetini sonlandırması durumunda, hizmetleri değiştirme veya sonlandırma hakkını kullanmak için size önceden bildirimde bulunmasına gerek yoktur. Fesih, fesih duyurusunun yayınlandığı tarihten itibaren bu internet sitesinden geçerli olacaktır.",
        content70: "5.7 Bu web sitesi, bu web sitesinin normal işleyişini sağlamak, gerekli ve güvenilir ticaret ortamını ve alım satım hizmetlerini sağlamak ve dijital varlık işlemlerinin düzenini korumak için gerekli teknik araçları ve yönetim önlemlerini alacaktır.",
        content71: "5.8 Üyelik hesabınızı ve şifrenizi kullanarak bu siteye bir yıl üst üste giriş yapmazsanız, bu site hesabınızı iptal etme hakkına sahiptir. Hesap iptal edildikten sonra bu site, ilgili üye adını kayıt ve kullanım için diğer kullanıcılara açma hakkına sahiptir.",
        content72: "5.9 Bu web sitesi, teknoloji yatırımını güçlendirerek, güvenlik önlemlerini ve diğer önlemleri iyileştirerek dijital varlıklarınızın güvenliğini sağlar ve hesabınızda öngörülebilir güvenlik riskleri oluştuğunda sizi önceden bilgilendirir.。",
        content73: "5.10 Bu web sitesi, bu web sitesinde yer alan, yasa ve düzenlemelere veya bu web sitesinin düzenlemelerine uymayan her türlü içerik bilgisini herhangi bir zamanda silme hakkına sahiptir. Bu web sitesinin bu hakları kullanmak için önceden size bildirimde bulunmasına gerek yoktur.",
        content74: "5.11 Bu web sitesi, egemen ülkenizin veya bölgenizin yasalarına, düzenlemelerine, kurallarına, emirlerine ve diğer düzenleyici gerekliliklerine uygun olarak daha fazla bilgi veya materyal sağlamanızı ve yerel düzenleyici gerekliliklere uymak için makul önlemleri almanızı talep etme hakkına sahiptir. işbirliği yapmakla yükümlüsünüz; bu web sitesi, egemen ülkenizin veya bölgenizin kanunları, düzenlemeleri, kuralları, emirleri ve diğer spesifikasyonlarına uygun olarak bu web sitesinin hizmetlerinin bir kısmını veya tamamını size açmayı askıya alma veya kalıcı olarak durdurma hakkına sahiptir.",
        content75: "5.12 Bu web sitesi, tamamen kendi takdirine bağlı olarak, yedi iş günü önceden bildirimde bulunarak hesabınızı kapatma hakkını saklı tutar. Bu nedenle emirleri iptal etmek ve pozisyonları kapatmak için yedi iş gününüz var. Süre dolduğunda emri iptal etmediyseniz ve pozisyonu kapatmadıysanız, emri zorla iptal edip pozisyonu kapatacağız ve hesabınızda kalan dijital varlıkları size iade edeceğiz.",
        content76: "5.13 Tüccarların haklarını ve çıkarlarını korumak amacıyla, bu web sitesi özel koşullar altında (sistem arızası, ağ arızası, aşırı piyasa koşulları vb. gibi) çevrimiçi ürünlerde aşağıdaki gibi ayarlamalar yapma hakkına sahiptir: erken teslimat sözleşmeleri ve uzlaşma, sözleşme türleri ve erken teslim ve uzlaşmaya ilişkin sözleşmeler, süre ve uzlaşma ve teslim bedeli bu sitede duyurulmaya tabidir.",
        content77: "6. Tazminat",
        content78: "6.1 Hiçbir durumda, doğrudan zararlara ilişkin olarak size karşı sorumluluğumuz, üç (3) aylık bir süre boyunca bu web sitesini kullanmanız karşılığında sizden tahsil ettiğimiz toplam hizmet ücretlerini aşmayacaktır.",
        content79: "6.2 Bu Sözleşmeyi veya diğer yasa ve düzenlemeleri ihlal ederseniz, bize en az 2 milyon ABD Doları tutarında tazminat ödemeniz ve oluşan tüm masrafları (avukat ücretleri vb. dahil) karşılamanız gerekir. Bu, fiili kayıpları telafi etmek için yeterli değilse, tazminat ödemeniz gerekir. buna hazırız.",
        content80: "7. İhtiyati tedbir isteme hakkı",
        content81: "Biz ve siz, sözleşme ihlalinize veya olası sözleşme ihlaline ilişkin genel hukuk çözümlerinin, uğradığımız tüm kayıpları telafi etmek için yeterli olmayabileceğini kabul ediyoruz; bu nedenle, genel hukuk veya hakkaniyetin izin verdiği ölçüde, Sözleşmenin ihlali veya sözleşmenin olası ihlali durumunda diğer tüm telafiler.",
        content82: "8. Sorumluluğun Sınırlandırılması ve Sorumluluk Reddi",
        content83: "8.1 Aşağıdaki konularda hiçbir koşulda sorumlu olmayacağımızı anlıyor ve kabul ediyorsunuz:：",
        content84: "8.1.1 gelir kaybı；",
        content85: "8.1.2 Ticari karlar veya sözleşme zararları；",
        content86: "8.1.3 İş kesintisinden kaynaklanan kayıplar；",
        content87: "8.1.4 Beklenen parasal tasarruf kaybı；",
        content88: "8.1.5 Bilgi sorunlarından kaynaklanan kayıplar；",
        content89: "8.1.6 Fırsat, iyi niyet veya itibar kaybı；",
        content90: "8.1.7 Veri bozulması veya kaybı；",
        content91: "8.1.8 İkame ürün veya hizmet satın alma maliyeti；",
        content92: "8.1.9 Haksız fiil (ihmal dahil), sözleşmenin ihlali veya başka herhangi bir nedenden kaynaklanan her türlü dolaylı, özel veya tesadüfi kayıp veya hasar, söz konusu kayıp veya zararın tarafımızca makul bir şekilde öngörülebilir olup olmadığına bakılmaksızın; Kayıp veya Hasar Olasılığı önceden.",
        content93: "8.1.1 8.1.9'un maddeleri birbirinden bağımsızdır.",
        content94: "8.2 Aşağıdaki durumlardan herhangi birinin size vereceği zararlardan sorumlu olmayacağımızı anlıyor ve kabul ediyorsunuz:：",
        content95: "8.2.1 Belirli işlemleriniz büyük yasa ihlallerini veya sözleşme ihlallerini içerebilir。",
        content96: "8.2.2 Bu web sitesindeki davranışınızın yasa dışı veya ahlaka aykırı olduğundan şüpheleniliyor。",
        content97: "8.2.3 Bu web sitesinin hizmetleri aracılığıyla veya bunların yerine geçen eylemler yoluyla herhangi bir veri, bilgi satın almak veya elde etmek veya işlem yürütmekten kaynaklanan masraflar ve kayıplar.",
        content98: "8.2.4 Bu web sitesinin hizmetleri hakkındaki yanlış anlamanız。",
        content99: "8.2.5 Bu web sitesi tarafından sağlanan hizmetlerle ilgili bizden kaynaklanmayan diğer kayıplar。",
        content100: "8.3 Bilgi ağı ekipmanlarının bakımı, bilgi ağı bağlantı arızası, bilgisayar, iletişim veya diğer sistem arızaları, elektrik kesintisi, hava koşulları, kazalar, grevler, iş anlaşmazlıkları, ayaklanmalar, ayaklanmalar, ayaklanmalar, yetersiz üretkenlik veya üretim malzemeleri, yangın, su baskını gibi durumlardan biz sorumluyuz. fırtınalar, patlamalar, savaşlar, banka veya diğer ortak nedenleri, dijital varlık piyasasının çöküşü, hükümet eylemleri, adli veya idari kurumların emirleri, kontrolümüz dışında olan veya kontrol etme yeteneğimizin olmadığı diğer eylemler veya üçüncü taraf nedenleri hizmetin sağlanamaması veya gecikmesi veya kayıplarınız konusunda herhangi bir sorumluluk kabul etmeyin.",
        content101: "8.4 Bu web sitesinde yer alan tüm bilgilerin, programların, metinlerin vb. tamamen güvenli olduğunu ve herhangi bir virüs, Truva atı ve diğer kötü amaçlı programlar tarafından müdahale edilmeyeceğini ve yok edilmeyeceğini garanti edemeyiz. Bu nedenle, siteye giriş yaparsanız ve herhangi bir hizmeti kullanırsanız. Bu web sitesini indirmek veya indirilen programları, bilgileri, verileri vb. indirmek ve kullanmak tamamen sizin kararlarınızdır ve riskleri ve olası kayıpları kendi sorumluluğunuzda üstlenirsiniz.",
        content102: "8.5 Bu web sitesine bağlantısı verilen herhangi bir üçüncü taraf web sitesine ait herhangi bir bilgi, ürün ve hizmete veya üçüncü şahısların sağladığı herhangi bir hizmet, bilgi ve hizmeti kullanmanız halinde bize ait olmayan herhangi bir içerik türüne ilişkin herhangi bir garanti veya taahhütte bulunmamaktayız. taraf web siteleri, Ürünler vb. tamamen sizin kararlarınızdır ve bunlardan doğan tüm sorumluluklar size aittir.",
        content103: "8.6 Bu web sitesi tarafından sağlanan hizmetlerin uygunluğu, hata veya eksiklik olmaması, sürekliliği, doğruluğu, güvenilirliği ve belirli bir duruma uygunluğu dahil ancak bunlarla sınırlı olmamak üzere, bu web sitesindeki hizmetleri kullanımınıza ilişkin açık veya zımni hiçbir garanti vermiyoruz. amaç. Aynı zamanda bu web sitesi tarafından sağlanan hizmetlerde yer alan teknoloji ve bilgilerin geçerliliği, doğruluğu, doğruluğu, güvenilirliği, kalitesi, istikrarı, eksiksizliği ve güncelliği konusunda herhangi bir taahhüt veya garanti vermiyoruz. Giriş yapmak veya bu web sitesi tarafından sağlanan hizmetleri kullanmak sizin kişisel kararınızdır ve kendi risklerinizi ve olası kayıplarınızı üstlenirsiniz. Dijital varlıkların piyasası, değeri ve fiyatı ile ilgili herhangi bir açık veya zımni garanti vermiyoruz. Dijital varlık piyasasının istikrarsız olduğunu anlıyor ve anlıyorsunuz. Fiyatlar ve değerler herhangi bir zamanda önemli ölçüde dalgalanabilir veya çökebilir. kişisel özgürlüğünüz. Riski ve olası kayıpları kendiniz seçer ve karar verirsiniz.",
        content104: "8.7 Bu Sözleşmede belirtilen garanti ve taahhütlerimiz, bu Sözleşme ve bu web sitesinde sağlanan hizmetlerle ilgili olarak tarafımızdan verilen tek garanti ve beyanlardır ve yazılı veya sözlü, açık, başka herhangi bir şekilde ortaya çıkan her türlü garanti ve taahhütlerin yerine geçer. veya ima edilir. Tüm bu garantiler ve beyanlar yalnızca bizim kendi taahhütlerimizi ve garantilerimizi temsil eder ve herhangi bir üçüncü tarafın bu Sözleşmedeki garanti ve taahhütlere uyacağını garanti etmez.",
        content105: "8.8 Bu Sözleşmede belirtilmeyen, zararlara ilişkin sorumluluğumuzu yürürlükteki kanunların tamamıyla sınırlamak, hariç tutmak veya telafi etmek için herhangi bir haktan feragat etmiyoruz.",
        content106: "8.9 Kayıt olduktan sonra bu sözleşmede belirtilen kurallara uygun olarak gerçekleştireceğimiz her türlü işlemi ve doğacak risklerin tarafınıza ait olacağını kabul etmiş olursunuz.",
        content107: "9. Sözleşmenin Feshi",
        content108: "9.1 Bu web sitesi, bu sözleşmeye uygun olarak bu web sitesinin tüm hizmetlerini sona erdirme hakkına sahiptir. Bu sözleşme, bu web sitesinin tüm hizmetlerinin sona erdirildiği tarihte sona erecektir.",
        content109: "9.2 Bu Sözleşmenin feshinden sonra, bu web sitesinin kendisine herhangi bir hizmet sağlamaya devam etmesini veya bu web sitesinin orijinal web sitesi hesabındaki herhangi bir bilgiyi saklamasını veya size ifşa etmesini zorunlu kılmak dahil ancak bunlarla sınırlı olmamak üzere başka herhangi bir yükümlülüğü yerine getirmesini talep etme hakkınız yoktur. Üçüncü taraf okumadığı veya göndermediği herhangi bir bilgiyi size veya üçüncü bir tarafa iletir.",
        content110: "9.3 Bu sözleşmenin feshi, ihlal etmeyen tarafın ihlal eden tarafa karşı diğer sorumluluklarını etkilemeyecektir.",
        content111: "10. Fikri mülkiyet hakları",
        content112: "10.1 Bu web sitesinde yer alan tüm fikri kazanımlar, web sitesi logolarını, veritabanlarını, web sitesi tasarımlarını, metin ve grafikleri, yazılımları, fotoğrafları, videoları, müzikleri, sesleri ve bunların kombinasyonlarını, yazılım derlemelerini, ilgili kaynak kodlarını ve yazılımları (küçük uygulamalar dahil) içerir ancak bunlarla sınırlı değildir. ) Programların ve scriptlerin fikri mülkiyet hakları bu siteye aittir. Yukarıdaki materyalleri veya içerikleri ticari amaçlarla çoğaltamaz, değiştiremez, kopyalayamaz, gönderemez veya kullanamazsınız.",
        content113: "10.2 Bu web sitesinin adının içerdiği tüm haklar (iyi niyet ve ticari markalar, logolar dahil ancak bunlarla sınırlı olmamak üzere) şirkete aittir.",
        content114: "10.3 Bu sözleşmeyi kabul etmeniz, bu web sitesinde yayınladığınız her türlü bilginin telif hakkını, bunlarla sınırlı olmamak üzere, aktarma girişiminiz olarak kabul edilecektir: çoğaltma hakları, dağıtım hakları, kiralama hakları, sergileme hakları, performans hakları, gösterim hakları, Telif hakkı sahibinin yararlanması gereken yayın hakları, bilgi internet iletim hakları, filme alma hakları, uyarlama hakları, çeviri hakları, derleme hakları ve diğer devredilebilir haklar münhasıran bu siteye ücretsiz olarak devredilmektedir. Bu sitenin bağımsız başvuru hakkı bulunmaktadır. Herhangi bir ihlale karşı dava açabilir ve tam tazminat alabilirsiniz. Bu sözleşme, içerik ister bu sözleşmenin imzalanmasından önce ister bu sözleşmenin imzalanmasından sonra oluşturulmuş olsun, bu web sitesinde yayınladığınız telif hakkı yasasıyla korunan her türlü çalışma içeriği için geçerlidir.",
        content115: "10.4 Bu web sitesinin hizmetlerini kullanırken bu web sitesinin veya başkalarının fikri mülkiyet haklarını yasa dışı olarak kullanamaz veya elden çıkaramazsınız. Bu web sitesinde yayınlanan bilgileri hiçbir şekilde başka web sitelerine (ve medyaya) yayınlayamaz veya kullanmaları için yetki veremezsiniz.",
        content116: "11. Bilgi koruması",
        content117: 'Bu sitede ayrıca yayınlanan "Gizlilik Koşulları" hükümleri geçerli olacaktır.',
        content118: "12. Hesaplama",
        content119: "Tüm işlem hesaplama sonuçları tarafımızca doğrulanmış ve tüm hesaplama yöntemleri sitede yayınlanmıştır ancak site kullanımının kesintisiz veya hatasız olmayacağını garanti edemeyiz.",
        content120: "13. İhracat Kontrolü",
        content121: "İlgili yasalara göre, bu web sitesindeki herhangi bir materyali (yazılım dahil) ihraç etmenize, yeniden ihraç etmenize, ithal etmenize veya aktarmanıza izin verilmediğini anlıyor ve kabul ediyorsunuz; dolayısıyla, bunlardan herhangi birini aktif olarak uygulamayacağınızı, yardımcı olmayacağınızı veya katılmayacağınızı garanti ediyorsunuz. Yukarıda belirtilen yasa ve yönetmelikleri ihlal eden ihracatlar veya ilgili faaliyetler. Transfer veya yürürlükteki yasa ve düzenlemelerin diğer ihlalleri; böyle bir durum tespit edilirse, bunu bize aktif olarak zamanında bildirmeli ve bu durumu ele almamıza yardımcı olmalısınız.",
        content122: "14. Transfer",
        content123: "İşbu Sözleşmede öngörülen hak ve yükümlülükler aynı zamanda bu hak ve yükümlülüklerden yararlanan tarafların devralanlarını, mirasçılarını, vasilerini ve idarecilerini de bağlar. Bunu bizim iznimiz olmadan herhangi bir üçüncü tarafa devredemezsiniz, ancak bu Sözleşmedeki haklarımızı ve yükümlülüklerimizi herhangi bir zamanda herhangi bir üçüncü tarafa devredebilir ve size bildirimde bulunabiliriz.",
        content124: "15. Bölünebilme",
        content125: "Bu Sözleşmenin herhangi bir hükmünün yetkili herhangi bir mahkeme tarafından uygulanamaz, geçersiz veya yasa dışı olduğuna karar verilmesi, bu Sözleşmenin geri kalan hükümlerinin geçerliliğini etkilemeyecektir.",
        content126: "16. Acentelik dışı ilişki",
        content127: "Bu Sözleşmedeki hiçbir şey, bu Sözleşmede aksi belirtilmediği sürece, bizi sizin temsilciniz, yediemininiz veya başka bir temsilciniz olarak yarattığı, ima ettiği veya başka bir şekilde teşkil ettiği kabul edilmeyecektir.",
        content128: "17. Çekimserlik",
        content129: "Herhangi bir tarafın sözleşmenin ihlaline ilişkin sorumluluğundan veya bu Sözleşmede belirtilen diğer yükümlülüklerden tarafımızdan veya tarafınızdan feragat edilmesi, sözleşmenin ihlaline ilişkin diğer yükümlülüklerden feragat olarak kabul edilmeyecek veya yorumlanmayacaktır; bu haklardan feragat veya vazgeçme çareleri olarak yorumlanabilir.",
        content130: "18. Başlık",
        content131: "Tüm başlıklar yalnızca sözleşmenin ifadesine kolaylık sağlamak içindir ve sözleşme koşullarının içeriğini veya kapsamını genişletmek veya sınırlamak için kullanılmaz.",
        content132: "19. Geçerli Kanun",
        content133: "19.1 Bir anlaşmazlığı dile getirmeden veya hak talebinde bulunmadan önce, anlaşmazlığı resmi olmayan bir şekilde çözmek için öncelikle bu web sitesiyle e-posta yoluyla iletişime geçeceğinizi onaylıyor ve kabul ediyorsunuz. gizli tutulacak ve geçerli kurallarla korunacak ve herhangi bir yasal işlemde delil olarak kullanılmayacaktır).",
        content134: '19.2 Bu Koşulların varlığı, geçerliliği, yorumlanması, uygulanması, ihlali veya feshi de dahil olmak üzere herhangi bir anlaşmazlık, ihtilaf, anlaşmazlık veya iddia durumunda ya da bu Koşullardan kaynaklanan veya bunlarla bağlantılı herhangi bir anlaşmazlığın ("Anlaşmazlık") olduğunu kabul ve beyan edersiniz. ), yukarıda belirtilen taraflar, anlaşmazlığı, o sırada yürürlükte olan "ICC Tahkim Kuralları" uyarınca Uluslararası Ticaret Odası Uluslararası Tahkim Divanı na ("ICC Uluslararası Tahkim Divanı") sunacaklardır. Tahkim yeri Belize olacak ve tahkime uygulanacak hukuk Uluslararası Ticaret Odası Tahkim Kurallarına göre belirlenecektir. Taraflarca aksi kararlaştırılmadıkça, ICC Tahkim Kurallarına göre yalnızca bir hakem atanacaktır. Hakem, tahkim anlaşmasının varlığına, kapsamına veya geçerliliğine itiraz veya herhangi bir iddia veya karşı iddianın tahkime elverişliliği dahil ancak bunlarla sınırlı olmamak üzere, kendi yargı yetkisine göre karar verme konusunda münhasır yetkiye sahip olacaktır. Her türlü tahkim İngilizce olarak yürütülecektir. Tahkimin nasıl yürütüldüğüne bakılmaksızın hakem, kararı ve varsa kararın dayandığı temel sonuçları açıklamaya makul ve yeterli olan yazılı bir karar verecektir. Tahkim kararı taraflar için nihai ve bağlayıcı olacak ve yetkili herhangi bir mahkemede icra edilebilecektir.',
        content135: "20. Anlaşmanın yürürlüğe girmesi ve yorumlanması",
        content136: "20.1 Bu sözleşme, kaydolmayı kabul etmek, kayıt işlemini tamamlamak ve bu web sitesi için bir hesap ve şifre almak üzere bu web sitesinin kayıt sayfasına tıkladığınızda yürürlüğe girer ve hem bu web sitesi hem de sizin için bağlayıcıdır.",
        content137: "20.2 Bu sözleşmenin nihai yorum hakkı bu web sitesine aittir.。",
        content138: "Müşterinizi ve kara para aklamayı önleme politikanızı tanıyın",
        content139: "1. Giriş",
        content140: '1.1 "Müşterinizi Tanıyın" ve kara para aklamanın önlenmesi ile ilgili yasa ve düzenlemelere titizlikle uyacağımıza ve "Müşterinizi Tanıyın ve Kara Para Aklamayı Önleme Politikası"nı kasıtlı olarak ihlal etmeyeceğimize söz veriyoruz. Makul kontrolümüz kapsamında, size güvenli hizmetler sunmak ve suç şüphelilerinin kara para aklama davranışlarından kaynaklanan kayıplardan sizi mümkün olduğunca korumak için gerekli önlemleri ve teknolojileri alacağız.',
        content141: "1.2 Müşterinizi Tanıyın ve Kara Para Aklamayı Önleme Politikamız, bağlı olduğunuz farklı yasal yargı bölgeleri için Müşterinizi Tanıyın ve Kara Para Aklamayı Önleme politikalarını içeren kapsamlı bir uluslararası politika sistemidir.",
        content142: "2. Müşterinizi tanıyın ve kara para aklamayı önleme politikaları aşağıdaki gibidir：",
        content143: "2.1 Müşterinizi tanıyın ve kara para aklamanın önlenmesi politikalarını yayınlayın ve bunları yürürlükteki yasa ve düzenlemeler tarafından belirlenen standartları karşılayacak şekilde zaman zaman güncelleyin；",
        content144: "2.2 Bu web sitesinin işletilmesine ilişkin bazı yol gösterici ilke ve kuralları yayınlamak ve güncellemek, çalışanlarımız bu ilke ve kuralların rehberliğinde hizmet sunacaktır.；",
        content145: "2.3 Kesin kimlik doğrulaması ve kara para aklamayı önleme çalışmalarından sorumlu profesyonel bir ekibin oluşturulması için düzenleme yapılması gibi işlemlerin dahili izlenmesi ve kontrolüne yönelik prosedürlerin tasarlanması ve tamamlanması；",
        content146: "2.4 Müşterilerin durum tespitini ve sürekli denetimini gerçekleştirmek için bir risk önleme yaklaşımı benimsemek；",
        content147: "2.5 Gerçekleşen işlemleri gözden geçirin ve düzenli olarak kontrol edin；",
        content148: "2.6 Şüpheli işlemleri yetkili makamlara bildirin；",
        content149: "2.7 Kimlik kanıtı, adres ve işlem kayıtları en az altı yıl süreyle saklanacak ve size başka bir bildirimde bulunulmaksızın düzenleyici makamlara sunulabilecektir.",
        content150: "3. Kimlik bilgileri ve doğrulama",
        content151: "3.1 Kimlik Bilgileri",
        content152: "3.1.1 Farklı yetki alanlarındaki ve farklı kuruluş türlerindeki farklı düzenlemelere göre, topladığımız bilgilerin içeriği tutarsız olabilir. Prensip olarak aşağıdaki bilgiler kayıtlı kişilerden toplanacaktır.：",
        content153: "Temel kişisel bilgiler: adınız, adresiniz (ve farklıysa daimi adresiniz), doğum tarihiniz ve uyruğunuz ve mevcut diğer bilgiler. Kimlik doğrulaması, pasaport, kimlik kartı veya farklı yargı mercileri tarafından gerekli görülen ve tetiklenen diğer kimlik belgeleri gibi resmi veya benzeri makamlar tarafından verilen belgelere dayanmalıdır. Verdiğiniz adres, yolcu taşıma biletinin veya faiz oranı notunun kontrol edilmesi veya seçmen kütüğünün kontrol edilmesi gibi uygun yöntemler kullanılarak doğrulanacaktır.",
        content154: "Geçerli Fotoğraf: Kayıt olmadan önce kimliğinizi göğsünüze dayadığınız bir fotoğrafınızı sunmalısınız.；",
        content155: "İletişim bilgileri: Telefon/cep telefonu numarası ve/veya geçerli e-posta adresi.",
        content156: "3.1.2Bir şirket veya başka bir tüzel kişilik iseniz, sizi veya emanet hesabınızın nihai yararlanıcısını tanımlamak için aşağıdaki bilgileri toplayacağız.",
        content157: "Şirket tescil ve tescil belgesi; şirketin ana sözleşmesinin ve protokolünün kopyaları; şirketin bu web sitesindeki hesabın açılmasını ve yürütülmesini belirleyen, şirketin özsermaye yapısı ve mülkiyet tanımına ilişkin ayrıntılı sertifika materyalleri; Gerektiğinde sağlanması gereken yöneticiler, ana hissedarın ve bu sitedeki hesabı imzalamaya yetkili kişinin kimlik belgeleri; şirketin ana iş adresi, şirketin posta adresinden farklı ise posta adresini belirtiniz. Bir şirketin yerel adresi ana işletme adresiyle tutarsızsa, bu şirket daha yüksek riskli bir müşteri olarak kabul edilir ve ek ek belgeler sunması gerekir.",
        content158: "Farklı yetki alanlarındaki ve farklı kuruluş türlerindeki farklı düzenlemelere bağlı olarak, gerekli gördüğümüz belgelerin yanı sıra yetkililer tarafından verilen başka sertifikalar ve belgeler de talep ediyoruz.",
        content159: "3.1.3 Kimlik bilgilerinin yalnızca İngilizce veya Çince versiyonlarını kabul ediyoruz. Aksi takdirde, lütfen kimlik bilgilerinizi İngilizceye tercüme edip notere tasdik ettirin.",
        content160: "3.2 Doğrula Onayla",
        content161: "3.2.1Kimlik belgenizin tam sayfa içeriğini sağlamanızı rica ediyoruz.",
        content162: "3.2.2 Kimlik belgenizi göğsünüze yasladığınız bir fotoğrafınızı ibraz etmenizi rica ediyoruz.",
        content163: "3.2.3 Destekleyici belgelerin kopyaları genellikle orijinal makbuzlarla karşılaştırılarak kontrol edilmelidir. Bununla birlikte, uygun ve güvenilir bir onaylayıcının, kopyanın orijinal belgenin doğru ve eksiksiz bir kopyası olduğunu tasdik etmesi halinde, kopya kabul edilebilir. Bu tür onaylayıcılar arasında büyükelçiler, adli komiserler, yerel hakimler vb. yer alır.",
        content164: "3.2.4 Nihai yararlanıcıyı ve hesabın kontrolünü belirleme gerekliliği, doğrudan müşterinin nihai olarak hangi kişilerin sahibi olduğunu veya kontrol ettiğini belirlemek ve/veya devam eden işlemlerin başkaları adına yürütüldüğünü tespit etmektir. Bir işletme ise, büyük hissedarların (örneğin %10 veya daha fazla oy hakkına sahip olanlar) kimlikleri doğrulanmalıdır. Genel olarak %25 oranında hisseye sahip olmak normal riskli kabul edilecek olup, hissedarın kimliğinin doğrulanması gerekmektedir; %10 oranında hisseye sahip olmak veya daha fazla oy hakkına veya hisseye sahip olmak yüksek riskli durum olarak değerlendirilmektedir, ve hissedarın kimliğinin doğrulanması gerekmektedir.",
        content165: "4. İşlemleri izleyin",
        content166: "4.1 Güvenlik ve gerçek işlem koşullarına göre günlük işlem ve para çekme maksimum limitlerini zaman zaman belirliyor ve ayarlıyoruz.;",
        content167: "4.2 Kayıtlı bir kullanıcıda işlemlerin sık sık gerçekleşmesi veya makul olmayan durumların mevcut olması durumunda, profesyonel ekibimiz bunların şüpheli olup olmadığına değerlendirecek ve karar verecektir.;",
        content168: "4.3 Kendi kanaatimize göre bir işlemin şüpheli olduğunu tespit edersek, işlemi askıya almak, işlemi reddetmek gibi kısıtlayıcı tedbirler alabilir, hatta mümkün olan en kısa sürede işlemi tersine çevirerek yetkili makama bildirebiliriz, ancak size bildirimde bulunmayacaktır.;",
        content169: "4.4 Uluslararası kara para aklamayla mücadele standartlarına uymayan yargı bölgelerindeki kişilerin veya siyasi nüfuz sahibi kişiler olarak kabul edilebilecek kişilerin kayıt başvurularını reddetme hakkımızı saklı tutuyoruz. ancak bunu size karşı olan yükümlülüklerinizden veya sorumluluklarınızdan herhangi birini ihlal etmeyiz.",
    },
    register: {
        emailRegister: "e-posta kaydı",
        phoneRegister: "Telefonunuzu kaydedin",
        formTitle1: "yaratmak",
        formTitle2: "E-postanızı veya cep telefonu numaranızı kullanarak kaydolun",
        formTitle3: "Hesap",
        field1: "Doğrulama kodu",
        field2: "Elde etmek",
        field3: "Şifreyi Onayla",
        field4: "Davet Kodu",
        field41: "（İsteğe bağlı）",
        field5: "okudum ve kabul ediyorum",
        field6: "Kullanım Şartları",
        placeholder1: "lütfen doğrulama kodunu girin",
        content7: "lütfen doğrulama kodunu girin",
        content12: "Lütfen telefon numarasını girin",
        content13: "Lütfen şifre giriniz",
        content14: "lütfen e-posta adresinizi girin",
        content18: "Lütfen şifreyi tekrar girin",
        content19: "Lütfen hizmet koşullarını kabul ediniz",
        content20: "Lütfen doğru doğrulama kodunu girin",
        content23: "Doğrulama kodunuzu hâlâ almadınız mı?",
        content24: "Lütfen doğrulama kodunu aşağıya girin",
        registerSuccess: "başarılı Kayıt",
        content25: "Şifreler tutarsız",
        content26: "Lütfen doğru e-posta adresini girin",
        content27: "Şifre sıfırlama başarılı"
    },
    download: {
        content1: "İstediğiniz zaman, istediğiniz yerde ticaret yapın",
        content2: "Birden fazla terminalle mükemmel uyumlu olup, çeşitli senaryoların işlem ihtiyaçlarını her zaman karşılar",
        content3: "İstediğiniz zaman gerçek zamanlı piyasa koşullarını kontrol edin",
        content4: "BTC, ETH, XRP ve diğer dijital varlıkları kolayca satın alın ve satın",
        content5: "Önemsediğiniz kripto para birimleri için fiyat değişikliklerine ilişkin erken uyarı alın",
        content6: "Bitcoin spot kredisini, vadeli işlem kredisini ve opsiyon fiyatlarını görüntüleyin",
        content7: "Çeşitli borsalardaki kripto para birimi fiyatlarını karşılaştırın",
        title: "indirmek",
        install: "yükleme notları",
        one: "1、Açıklama dosyalarının indirilmesine izin ver",
        two: "2、Açıklama dosyası indirildi",
        three: "3、Telefonunuzda [Ayarlar]'a gidin ve [Genel]'i bulun",
        four: "4、Profiller ve Cihaz Yöneticisi",
        five: "5、Profile tıklayın",
    },
    identity: {
        noAuthentication: {
            title: "Genç Sertifikası",
            pleaseSelectYourCountry: "Lütfen ülkenizi seçiniz",
            name: "İsim",
            enterName: "Lütfen adınızı giriniz",
            city: "şehir",
            enterCity: "Lütfen şehrinizi girin",
            IDNumber: "kimlik Numarası",
            enterIDNumber: "Lütfen kimlik numaranızı giriniz",
        },
        noAdvancedAuthentication: {
            title: "Gelişmiş sertifikasyon",
            infoCountry: "ülke / bölge",
            infoName: "İsim",
            infoNumber: "kimlik Numarası",
            infoAddress: "adres",
        },
        text: "sertifikalı değil",
        recertification: "yeniden sertifikalandırma",
        certification: "Sertifikasyon",
        authenticationInProgress: "doğrulandı",
        inAuthentication: "Sertifikasyon devam ediyor",
        uploadTheFrontOfTheDocument: "Kimliğin ön yüzünü yükleyin",
        uploadTheReverseSideOfTheDocument: "Sertifikanın arka tarafını yükleyin",
        uploadAPhotoOfAHandHeldID: "Kimlik kartınızın elinizdeki fotoğrafını yükleyin",
        pleaseUpload: "Lütfen ",
        pleaseCompleteOrdinaryCertificationFirst: "Birincil sertifika incelemesinin başarısını beklemeniz gerekiyor",
        refused: "Reddedilmiş",
        reason: "sebep",
        succeeded: "Başarılı",
        uploading: "yükleniyor",
        newTitle: "Kimliğinizin verildiği ülkeyi seçin",
        pleaseOrdinaryCertificationFirst: "Lütfen önce birincil sertifikasyon işlemini gerçekleştirin",
        text1: "Avatarı değiştir",
        text2: "Takma ad",
        text3: "hesap",
        text4: "Takma ad değişikliği",
        text5: "yeni takma ad",
        text6: "Yeni takma adınızı girin",
        text7: "eski Şifre",
        text8: "Eski şifrenizi girin",
        text9: "Yeni Şifre",
        text10: "Yeni şifrenizi giriniz",
        text11: "Şifreyi Onayla",

        text12: "Yeni şifrenizi tekrar girin",
        text13: "yeni posta kutusu",
        text14: "Doğrulama kodu",
        text15: "lütfen doğrulama kodunu girin",
        text16: "Senin cep telefonu numaran",
        text17: "Yeni cep telefonu numarası",
        text18: "lütfen telefon numaranızı girin",
        text19: "Cep telefonu doğrulama kodu",
        text20: "Genç Sertifikası",
        text21: "Lütfen kimlik bilgilerinizi doğrulayın",
        text22: "Ülke",
        text23: "Şehir",
        text24: "Şehrinizi girin",
        text25: "Adınızı giriniz",
        text26: "Kimlik numaranız",
        text27: "Kimlik numaranızı girin",
        text28: "Kimlik kartı ön fotoğrafı",
        text29: "Belgelerinizi yüklemek için tıklayın",
        text30: "yeniden yükle",
        text31: "yüklemek",
        text32: "Kimlik fotoğrafı tutma",
        text33: "Kimlik fotoğrafınızı yüklemek için tıklayın",
        text34: "Google Authenticator'ı bağladınız",
        text35: "anahtar",
        text36: "Lütfen Google doğrulama kodunu girin",
        text37: "Göndermek",
        text38: "Boş olamaz",
        text39: "E-posta formatı yanlış",
        text40: "İki şifre tutarsız",
        text41: "Başarıyla kopyalandı",
        text42: "Kopyalama başarısız oldu",
        text43: "Avatar değişikliği",
        text44: "şifre değiştir",
        text45: "E-posta bağlama",
        text46: "E-postayı değiştir",
        text47: "Cep telefonu bağlama",
        text48: "Cep telefonunu değiştir",
        text49: "Google doğrulaması",
        text50: "Google Authenticator'ı bağlayın",
        text51: "Google doğrulama kodunu girin",
        text52: "kaydetmek",
        text53: "Gönderimi Onayla",
        text54: "Revize",
        text55: "bağlayıcı",
        text56: "Google doğrulamasını kapat",
        text57: "Sonraki adım",
        text58: "Sona ermek",
        text59: "Google doğrulaması bağlı",
        text60: "Google doğrulaması ayrıştırıldı",
        text61: "Birincil sertifika gönderildi",
        text62: "Gelişmiş Sertifika Gönderildi",
        text63: "Resim yüklenmedi",
        text64: "Yeniden gönder",
        text65: "Lütfen bir takma isim giriniz",
        text66: "Takma ad başarıyla kaydedildi",
        text67: "Henüz resim yüklenmedi",
        text68: "Şifre sıfırlama tamamlandı",
        text69: "E-posta başarıyla değiştirildi",
        text70: "Avatar başarıyla kaydedildi",
        text71: "Fotoğraf yükleniyor",
        text72: "posta kutunuz",
        text73: "Yeni e-postanızı girin",
        text74: "Adınız",
        text75: "Kimlik doğrulamaya git",
        text76: "Lütfen kimlik fotoğrafınızı doğrulayın"
    },
    retrievePassword: {
        formTitle1: "şifreyi yenile",
        formTitle2: "Varlıklarınızın güvenliği açısından şifre değişiminden sonraki 24 saat içerisinde işlem yapılması yasaktır.",
        formTitle3: "Parola Al",
        formTitle4: "Değişiklikleri onaylayın",
        formTitle5: "Lütfen eski şifreyi girin",
        formTitle6: "Lütfen yeni bir şifre girin",
        formTitle7: "Cep telefonu kurtarma",
        formTitle8: "E-posta alımı"
    },
    home: {
        title1: "En Popüler Kripto Para Ticaret Platformu",
        title3: "neden ki ",
        title4: " Güvenli, uyumlu ve öngörülebilir dijital altyapıyı desteklemek ve işletmek için tasarlanmış, yüksek performanslı, açık kaynaklı bir blockchain platformudur.",
        field1: "Kurulu borsa",
        field2: "Dijital varlık finansal hizmetleri",
        field3: "On milyonlarca kullanıcı",
        field4: "Birden fazla yatırımcı koruma fonu oluşturun",
        field5: "Hızlı Ticaret",
        field6: "CME Grup, en üst düzey ticaret deneyimi için emirleri ultra düşük gecikmeyle eşleştirebiliyor.",
        title5: "piyasa eğilimi",
        title6: "daha fazla gör",
        table1: "Para birimi",
        table2: "Son fiyat",
        table3: "24 saat iniş ve çıkışlar",
        table4: "24 saatlik işlem hacmi",
        table5: "24 saatlik işlem hacmi",
        table6: "Alıntılar",
        title7: "hakkında ",
        title8: " Kullanıcılara en gelişmiş ticaret araçlarını, yenilikçi teknolojiyi ve benzersiz kalitede müşteri hizmetini sunmaya kararlıyız.",
        title9: "Dijital varlıkların alanı her geçen gün değişiyor ancak ileriyi görerek ve hızlı ilerleme kaydederek teknolojik yeniliğin hızına ayak uydurabiliriz.",
        title901: " Kullanıcılarımıza ve küresel likidite sağlayıcılarımıza en gelişmiş dijital varlık alım satım hizmetlerini sağlamak。",
        title10: "Her kullanıcının en iyi ticaret deneyimini hak ettiğine kesinlikle inanıyoruz。",
        title11: "Güvenebileceğiniz güvenlik",
        title12: "Gelişmiş güvenlik önlemlerimiz ve SAFU fonlarımız dijital varlıklarınızı tüm risklerden korur。 ",
        title13: "En iyi işlem oranları",
        title14: "Tercihli işlem oranları, rekabetçi VIP hakları ve en kaliteli hizmetlerin keyfini çıkarın.",
        title15: "24*7 saat müşteri hizmetleri desteği",
        title16: "7/24 her türlü hava koşulunda, tam zamanlı çalışma modunda, ilgili sorularınızı en kısa sürede yanıtlayacağız.",
        title17: "0 ücretle ticaret",
        title18: "Sıfır işlem ücretiyle, güvenli ve hızlı bir şekilde dijital para birimleriyle işlem yapmak için birden fazla ödeme yöntemi kullanın.",
        title19: "İstediğiniz zaman, istediğiniz yerde ticaret yapın",
        title20: "Birden fazla terminalle mükemmel uyumlu olup, çeşitli senaryoların işlem ihtiyaçlarını her zaman karşılar",
        title21: "İstediğiniz zaman gerçek zamanlı piyasa koşullarını kontrol edin",
        title22: "BTC, ETH, XRP ve diğer dijital varlıkları kolayca satın alın ve satın",
        title23: "Önemsediğiniz kripto para birimleri için fiyat değişikliklerine ilişkin erken uyarı alın",
        title24: "Bitcoin spot kredisini, vadeli işlem kredisini ve opsiyon fiyatlarını görüntüleyin",
        title25: "Çeşitli borsalardaki kripto para birimi fiyatlarını karşılaştırın",
        title26: "Şimdi kayıt ol",
        title27: "Dolar",
        title28: "24 saatlik işlem hacmi",
        title29: "Entegre Likidite Sağlayıcısı",
        title30: "kullanıcı",
        title31: "Daha",
        title32: "Binance Kredi, CTSI ve KSM'yi teminat varlıkları olarak ekliyor ve BUSD ve USDT faiz oranı indirim indirimlerini başlatıyor!",
        title33: "Bizim avantajımız",
        title34: "güvenli ve istikrarlı",
        title35: "Üst düzey teknik ekip, kapsamlı güvenlik koruması, yüksek hızlı işlem sentezi motorunun bağımsız araştırması ve geliştirilmesi, büyük eşzamanlı işlemler altında hala istikrarlı ve güvenilir bir şekilde çalışabilir.",
        title36: "Profesyonel Uyumluluk",
        title37: "Blockchain ve finans alanında uzun yıllara dayanan deneyime sahip profesyonel operasyon ekibi, uyumlu bir dijital varlık alım satım lisansına ve %100 rezerv garantisine sahiptir.",
        title38: "Önce kullanıcı",
        title39: "Küresel pazara dönük, birden fazla dili destekleyen, 7/24 çalışan, güçlü topluluk desteği ve profesyonel müşteri hizmetleri.",
        title40: "yüksek performans",
        title41: "Saniyede 300.000 işlem ve 1 milisaniyeden kısa sipariş yanıt süresi.",
        title42: "Hakkımızda",
        title43: "İstediğiniz zaman, istediğiniz yerde ticaret yapın",
        title44: "Birden fazla terminalle mükemmel uyumlu olup, çeşitli senaryoların işlem ihtiyaçlarını her zaman karşılar",
        title45: "（İndirmek için kodu tarayın）",
        title46: "Dijital Para Haberleri",
        title47: "iş ortağımız",
        title48: "Kaybeden listesi",
        title49: "24 saatlik ciro",
        title50: "24 saatlik artış ve düşüş"
    },
    quotation: {
        marketTrading: "Alıntılar",
        turnover: "Hacim",
        optional: "İsteğe bağlı",
        contractMarket: "sözleşme piyasası",
        currencyPair: "döviz çifti",
        latestPrice: "Kapanış fiyatı",
        upsAndDowns: "Teklif değişikliği",
        highest: "En yüksek",
        lowest: "en düşük",
        transactionAmount: "İşlem hacmi",
        operate: "işletmek",
        buy: "ticaret",
        topTurnovers: "İşlem listesi",
        topGainers: "Kazanan listesi",
        tradingPair: "ticaret çifti",
        buyOrder: "Satın almak",
        sellOrder: "satış emri"
    },
    accountChange: {
        demo: "simülasyon",
        realAccount: "gerçek hesap",
        demoAccount: "Demo hesabı",
        accountRole: "Hesap rolü",
        pleaseSelect: "lütfen seç",
        AccountChangeType: "Hesap değişikliği türü",
        AccountType: "hesap tipi",
        currencyType: "Para birimi türü",
        allType: "Her türlü",
        allAccount: "Bütün hesaplar",
        allCoin: "Tüm para birimleri",
        coin: "Para birimi",
        amount: "Tutarı değiştir",
        balance: "Hesap bakiyesi",
        time: "zaman",
        title: "Hesap değişikliği kayıtları",
        filtrar: "filtre",
        check: "çevirmek",
        showOnly: "Yalnızca para birimi varlıklarını göster",
        holdAssets: "Döviz bakiyesi",
        accountList: "Hesap listesi"
    },
    contractTransaction: {
        chart: "çizelge",
        basicEdition: "Temel sürüm",
        depthMap: "Derinlik haritası",
        second: "Saniye",
        minute: "nokta",
        day: "gökyüzü",
        week: "hafta",
        month: "ay",
        open: "açık",
        trade: "ticaret",
        buyLong: "uzun satın alma",
        buyShort: "kısa satın alma",
        cannotBuy: "Bu para birimi teslimat sözleşmesi işlemlerini desteklemiyor",
        cannotBuy1: "Bu para birimi sürekli ticareti desteklemiyor",
        tradingAssets: "ticari varlıklar",
        amountAvailable: "Mevcut miktar",
        timeStr: "zaman",
        transactionPeriod: "ticaret dönemi",
        quantity: "miktar",
        enterQuantity: "Lütfen miktarı girin",
        buyIn: "Uzun git",
        latestTransaction: "son işlem",
        time: "zaman",
        direction: "yön",
        price: "fiyat",
        sell: "kısa",
        positionOrder: "Teslimat siparişi",
        historicalOrders: "Tarihsel siparişler",
        product: "ürün",
        realAccount: "(gerçek hesap)",
        demoAccount: "(Demo hesabı)",
        openingTime: "sipariş zamanı",
        openingPrice: "Açılış fiyatı",
        curretPrice: "Mevcut fiyat",
        liquidationPrice: "Kapanış fiyatı",
        profitOrLoss: "Kar ve zarar",
        endTime: "Kapanış saati",
        areYouSureToBuy: "Satın almak istediğinizden emin misiniz?",
        areYouSureToLongBuy: "Uzun süre gitmek istediğinden emin misin?",
        areYouSureToShortBuy: "Kısa alım yapmak istediğinizden emin misiniz?",
        successfullyBought: "Başarıyla satın alın",
        minBuy: "Minimum katılım",
        assets: "varlıklar",
        withdraw: "Para Çek",
        entrustedOrder: "Sipariş",
        total: "Toplam",
        continueToPlaceOrder: "Sipariş vermeye devam",
        orderConfirmation: "Sipariş onayı",
        buyRu: "satın almak",
        sellChu: "satmak",
        areYouSureToSell: "Satmak istediğinizden emin misiniz?",
        operation: "işletmek",
        buyCover: "kapak konumu",
        commitSuccess: "İşlem başarılı",
        onlyEnterIntegers: "Yalnızca tam sayılar girilebilir",
        trend: "Akım",
        lotteryTime: "Sipariş için son tarih",
        countdown: "geri sayım",
        period: "Sorun",
        cycle: "Zaman dilimi",
        unlimited: "Sınırsız",
        put: "PUT",
        call: "CALL",
        pending: "Komisyonda",
        unopened: "Henüz çizilmedi",
        opened: "Ödül çekildi",
        settlementPrice: "Uzlaşma Fiyatı",
        rateOfReturn: "getiri oranı",
        currentPositions: "Şu anki pozisyon",
        positionQuantity: "Pozisyon miktarı",
        guarantee: "marj",
        text1: "yükselmek",
        text2: "düşmek",
        text3: "Satın almayı bekliyorum",
        text4: "Sipariş Miktarı",
        text5: "İşlem sayısı",
        text6: "İptal etmek",
        text7: "teslimat süresi",
        text8: "İptal hatırlatıcısı",
        text9: "Siparişi iptal etmek istediğinizden emin misiniz?",
        text10: "Yasa dışı miktar",
        text11: "Sipariş hatırlatıcısı",
        text12: "Yükseliş satın aldığınızdan emin misiniz?",
        text13: "Putu satın almak istediğinden emin misin?",
        text14: "İptal başarılı"
    },
    mining: {
        title1: "Dünyanın önde gelen blockchain dijital varlık madenciliği platformu",
        title2: "Açık ve şeffaf · güvenli ve istikrarlı",
        title3: "Lütfen para birimini seçin",
        title4: "Madencilik Yıllık Getirisi",
        title5: "gökyüzü",
        title6: "Madencilik dönemi",
        title7: "Ürün Detayları",
        btn: "Şimdi benim",
        btn2: "kapatma",
        tabs1: "devam etmekte",
        tabs2: "kurtarılmış",
        table1: "Ürün adı",
        table2: "Madencilik dönemi",
        table3: "Madencilik zamanı",
        table4: "Madencilik miktarı",
        table5: "Son kullanma tarihi",
        table6: "Vadeye kadar ilerler",
        table7: "Sipariş durumu",
        egularMining: "Düzenli olarak madencilik",
        inProgress: "devam etmekte",
        redeemed: "kurtarılmış",
        redemption: "kefaret",
        regularMining: "Düzenli olarak madencilik",
        earlyRedemption: "erken ödeme",
        need: "ihtiyaç",
        handlingFee: "Hizmet bedeli",
        redemptionConfirmationMessage: "Lütfen önceden kullanıp kullanmayacağınızı onaylayın？",
        form1: "Madencilik Yıllık Getirisi",
        form2: "Madencilik dönemi",
        form3: "Madencilik para birimi",
        form4: "Abonelik tutarı (minimum/maksimum)",
        form5: "Erken kullanım ücreti: ",
        form6: "satın alma bedeli",
        form7: "Mevcut fonlar",
        form8: "satın alma bedeli",
        form9: "Mevcut fonlar",
        form10: "Lütfen satın alma tutarını girin",
        form11: "Tümü",
        form12: "Tahmini gelir",
        form13: "Yetersiz fon mevcut",
        form14: "Lütfen satın alma tutarını girin",
        form15: "Benim siparişim",
        form16: "gelir",
        form17: "sipariş detayları",
        form18: "Erken ödeme talimatları:",
        form19: "Abonelik tutarı (minimum)",
        form20: "Abonelik tutarı (maksimum)",
        form21: "Tutulan miktar",
        form22: "Zaman satın alma",
        form23: "itfa zamanı",
        form24: "üzerinde",
        form25: "Abonelik başarılı",
        form26: "Ödeme başarılı",
        form27: "Kolay finansal yönetim, %25'in üzerinde getiri, piyasadan daha iyi performans ve satın alma sonrasında ödüller de alabilirsiniz",
        form28: "Arkadaşlarınızı 50 USDT tutarında bir ödül almaya davet edin; sözleşme kuponları da %20 komisyon getirebilir."
    },
    assets: {
        content1: "Hesap varlıkları",
        content2: "Bugünkü kazanç",
        content3: "mevcut hesap",
        content4: "Gerçek hesap, işlemler ve para çekme işlemleri için kullanılabilen gerçek hesap varlıklarınızdır.",
        content5: "Madeni para çekme",
        content6: "Para yatırma",
        content7: "değişme",
        content8: "Aktar",
        content9: "lütfen seç",
        content10: "Demo hesabı",
        content11: "gerçek hesap",
        content12: "varlık edinmek",
        content13: "Gerçek bir hesaba geçmek istediğinizden emin misiniz?",
        content14: "Demo hesaba geçmek istediğinizden emin misiniz?",
        content15: "başarı elde etmek",
        table1: "Para birimi",
        table2: "miktar",
        table3: "donmak",
        table4: "Mevcut",
        dialog1: "Ürün Detayları",
        dialog2: "1、Bu varlığın yalnızca demo hesap modunda kullanılmasına izin verilir",
        dialog3: "2、Kötüye kullanımı önlemek için bir ay içinde yalnızca bir kez kullanıma izin verilir.",
        dialog4: "3、Varlıkların alınması, başlangıçta alınan varlıkların miktarını ekleyecek ve pozisyon durumunu değiştirmeyecektir.",
        dialog5: "4、Başka sorularınız varsa lütfen müşteri hizmetlerine başvurun",
        dialog6: "kapatma",
        dialog7: "Demo varlıklarını hemen alın",
        dialog8: "transfer etmek",
        dialog9: "dışarı aktarma",
        dialog10: "anahtar",
        dialog11: "Değerleme",
        dialog12: "Demo varlıkları",
        dialog13: "hesabım",
        dialog14: "Toplam hesap varlıkları",
        dialog15: "Varlığa genel bakış",
        dialog16: "Toplam varlık değerlemesi",
        dialog17: "Varlık değerlendirmesi",
        dialog18: "Bugünkü kazanç",
        dialog19: "fonları dondur",
        dialog20: "Her ay simüle edilmiş varlık kotası alabilirsiniz",
        dialog21: "almak",
        dialog22: "Başarıyla aldınız",
        dialog23: '30 günlük kümülatif gelir',
        dialog24: "Finansal ürün",
        dialog25: "Finansal yönetimim",
        dialog26: "Tarihsel finans yönetimi",
        dialog27: "geçmiş kaydı",
        dialog28: "Finansman kayıtları"
    },
    validator: {
        dialog14: "doğrulayıcı",
        dialog15: "Bağlama doğrulayıcı",
        dialog16: "doğrulayıcı anahtarı",
        dialog17: "Doğrulama kodu",
        dialog18: "Doğrulayıcı QR kodu",
        dialog19: "doğrulayıcı anahtar",
        dialog20: "kaydetmek",
        dialog21: "Lütfen bir doğrulayıcı seçin",
        dialog22: "anahtarı kopyala",
        dialog23: "Başarıyla kaydedildi",
        dialog24: "lütfen doğrulama kodunu girin",
        dialog25: "Dostça bir hatırlatma: Kaydetmeyi onaylamadan önce lütfen ilgili uygulamayı açın ve aşağıdaki QR kodunu tarayın veya anahtarı manuel olarak ekleyin!",
        dialog26: "Hesabınıza maksimum güvenlik sağlamak için kimlik doğrulayıcınızı etkinleştirin。",
        dialog27: "Her giriş yaptığınızda veya para çektiğinizde, cep telefonunuz aracılığıyla erişilen benzersiz bir doğrulama kodunu girmeniz gerekecektir.。",
        dialog28: "Doğrulayıcıyı ayarla",
        dialog29: "yardım",
        dialog30: "Kimlik doğrulama kodunu bağlamadınız. Kimlik doğrulayıcıyla daha güçlü koruma elde edin.",
        dialog31: "Doğrulayıcı henüz kurulmadı, lütfen önce onu kurun",
        dialog32: "Ayarlara git"
    },
    recharge: {
        title1: "Dijital para birimini kullanarak nasıl satın alacağınızdan emin değil misiniz?",
        title2: "Sadece üç kolay adım!",
        title3: "Açılır menüden satın almak istediğiniz dijital para birimini seçin ve satın alma miktarını veya tutarını girin.",
        title4: "Tercih ettiğiniz ödeme yöntemini seçin",
        title5: "Ödeme onaylandıktan sonra satın aldığınız dijital para birimi otomatik olarak hesabınıza aktarılacaktır.",
        title6: "Lütfen yüklemek istediğiniz para birimini seçin",
        title7: "Mevduat kaydı",
        table1: "Para birimi",
        table2: "miktar",
        table3: "Zincir adı",
        table4: "durum",
        table5: "sebep",
        table6: "zaman",
        table7: "Kuponu görüntüle",
        dialog1: "Lütfen doğrulama kodunu aşağıya girin",
        dialog2: "ödeme kodu",
        dialog3: "kopyala",
        dialog4: "adres",
        dialog5: "Mevduat tutarı",
        dialog6: "İşlem Ekran",
        dialog7: "önemli Uyarı",
        dialog8: "Lütfen depozito tutarını girin",
        dialog9: "fotoğraf yükleniyor",
        dialog10: "Lütfen içeriği girin",
        dialog11: "Lütfen şarj işleminin ekran görüntülerini yükleyin",
        dialog12: "İncelenmedi",
        dialog13: "Reddedilmiş",
        dialog14: "Yatırıldı",
        tip1: "Başarıyla gönderildi",
        tip2: "Başarıyla kopyalandı",
        tip3: "Kopyalama başarısız oldu",
        tip4: "Lütfen yüklemek istediğiniz para birimini seçin",
        tip5: "1.Yukarıdaki para yatırma adresi platformun resmi ödeme adresidir. Lütfen platformun resmi para yatırma adresini arayın. Yanlış para yatırma işleminden kaynaklanan para kayıpları tarafınızca karşılanacaktır.；",
        tip6: "2.Bilgilerin tahrif edilmesini veya sızdırılmasını önlemek için lütfen bilgisayarınızın ve tarayıcınızın güvenli olduğundan emin olun.；",
        tip7: "3.Yukarıdaki adresi yeniden doldurduktan sonra, hesabın alınabilmesi için tüm ağ düğümünün onaylaması gerekir.；",
        tip8: "4.Lütfen yukarıdaki token sistemini ve para birimini seçin ve ilgili tutarı yatırın. Lütfen ilgisiz başka varlıkları transfer etmeyin, aksi halde geri alınmayacaktır.",
        tip9: "QR kodunu kaydet",
        tip10: "tamamlamak",
        tip11: "önemli Uyarı",
        tip12: "Site dışı bağlantılar",
        tip13: "QR kodunu şarj edin",
        tip14: "Sonraki adım",
        tip15: "Şarj kaydı",
        tip16: "Şarj ayrıntıları",
        tip17: "Para yatırma adresi",
        tip18: "Hızlı ödeme",
        tip20: "Yetersiz bakiye",
        tip22: "Gönderildi, onay bekleniyor",
        tip23: "Ödeme için bekleniyor",
        tip24: "Miktar",
        tip25: "Ödeme gönderildi, blok onayı bekleniyor",
        tip26: "Ödeme Reddedildi",
        tip27: "Ödeme Başarısız",
        tip28: "Ödeme başarılı",
        bankChannel: "Banka kartı kanalı",
        tip29: "Geçmiş aramalar",
        tip30: "Para birimi listesi",
        tip31: "Ağ seçin",
        tip32: "Bu para birimini yeniden doldurduğunuzda lütfen yalnızca aşağıdaki desteklenen ağlar üzerinden yükleme yapın. Diğer ağlar üzerinden yükleme yaparsanız paranız kaybolur.",
        tip33: "Bu para birimini çekerken lütfen yalnızca aşağıdaki desteklenen ağlar üzerinden çekim yapın. Diğer ağlar üzerinden çekim yaparsanız paranız kaybolur.",
        tip34: "Hızlı şarj",
        tip35: "Yeniden şarj etmek için kodu tarayın",
        tip36: "Manuel şarj",
        tip37: "Ağı yeniden şarj edin",

        tip38: "Şarj adresi",
        tip39: "Yeniden yükleme miktarı",
        tip40: "İşlem makbuzu yükleme",
        tip41: "fotoğraf yükleniyor",
        tip42: "gönderimi onayla",
        tip43: "ödemeyi Onayla",
        tip44: "Not: Lütfen şarj etmeniz gereken adresi doğrulayın. Yanlış doldurmanız durumunda oluşacak para kaybından sorumlu değiliz.",
        tip45: "hatırlatmak",
        tip46: "Adres başarıyla kopyalandı!",
        tip47: "Adres kopyalanamadı!",
        tip48: "Yetersiz kullanılabilir bakiye",
        tip49: "Yeniden yükleme başarıyla gönderildi ve zincirde onay bekleniyor.",
        tip50: "Yeniden şarj başarısız oldu",
        tip51: "Yükleme miktarı yanlış",
        tip52: "Bağlantı başarısız oldu",
        tip53: "Cüzdana giriş yapılmadı",
        tip54: "bağlantı reddedildi",
        tip55: "Başarıyla gönderildi, müşteri hizmetlerinin incelemesi ve onayı bekleniyor",
        tip56: "Lütfen işlem makbuzunun ekran görüntüsünü yükleyin",
        tip57: "Gönderim Başarısız",
        tip58: "Şarj kaydı",
        tip59: "Para çekme kaydı",
        tip60: "Para birimini yeniden yükle",
        tip61: "Para çekme para birimi",
        tip62: "Şarj adresi",
        tip63: "Ekran görüntüsü gösterileri",
        tip64: "Resmi büyütmek için tıklayın",
        tip65: "Şarj süresi",
        tip66: "Reddedilme nedeni",
        tip67: "Para Çekme Tutarı",
        tip68: "Alınan tutar",
        tip69: "Nakit çekme ağı",
        tip70: "Para çekme adresi",
        tip71: "Para çekme süresi",
        tip72: "kapatma",
        tip73: "İşlem Ekran",
        tip74: "Bekleyen yorum",
        tip75: "Reddedilmiş",
        tip76: "tamamlanmış",
        tip77: "Reddedilmiş",
        tip78: "Denetlendi",
        tip79: "Ödenen",
        tip80: "çıkarmak",
        tip81: "aktarım ağı",
        tip82: "Adres/Fatura",
        tip83: "Hepsini geri çek",
        tip84: "Lütfen doğrudan kitle fonlaması veya ICO adresine para çekmeyin, aksi takdirde kitle fonlaması veya ICO tarafından verilen tokenları alamayacaksınız.",
        tip85: "Varış miktarı",
        tip86: "çıkarmak",
        tip87: "Yanlış para çekme adresi",
        tip88: "Yanlış para çekme tutarı",
        tip89: "Çekilecek miktar en az",
        tip90: "Maksimum para çekme tutarı",
        tip91: "Para çekme talebi gönderildi",
        tip92: "adres listesi",
        tip93: "Henüz bir adres eklemediniz",
        tip94: "Şimdi ekle",
        tip95: "Adres Ekle",
        tip96: "yeni adres ekleyin",
        tip97: "lütfen seç",
        tip98: "adres",
        tip99: "Lütfen bir aktarım ağı seçin",
        tip100: "Lütfen adresi girin",
        tip101: "Adres başarıyla eklendi",
        tip102: "işlemde",
    },
    fundExchange: {
        title1: "Para değişimi nasıl yapılır?",
        title2: "Dönüştürülecek uygun para birimini seçin。",
        title3: "Dönüştürülecek uygun para birimini seçin。",
        title4: "Değiştirilecek tutarı girin ve fon değişimini tamamlamak için Gönder'e tıklayın.",
        title5: "itibaren",
        title6: "varmak",
        title7: "Değişim miktarı",
        title8: "Döviz kuru",
        title9: "Mevcut",
        title10: "Lütfen ödeme miktarını girin",
        title11: "Değişim için karşılık gelen bir işlem çifti yok.",
        title12: "Lütfen kullanılacak miktarı girin",
        title13: "Ödeme başarılı",
        title14: "Değişim kaydı",
        table1: "Para birimini kullan",
        table2: "miktar",
        table3: "Döviz kuru",
        table4: "Döviz kuru",
        table5: "Fiş",
        table6: "zaman",
        title15: "itibaren",
        title16: "Şu anda kullanılabilir varlık yok, lütfen başka bir tane seçin"
    },
    fundTransfer: {
        title1: "Para transferi nasıl yapılır?",
        title2: "Aktarılacak cari hesabı seçin。",
        title3: "Aktarmak istediğiniz hesabı seçin。",
        title4: "Transfer tutarını girin ve transferi tamamlamak için Gönder'e tıklayın.",
        title5: "Para birimi",
        title6: "Transfer miktarı",
        title7: "Lütfen transfer edilecek tutarı giriniz",
        title8: "aktarım kaydı",
        title9: "Lütfen cüzdan türünü seçin",
        title10: "Lütfen para birimini seçin",
        title11: "Lütfen cüzdan türünü seçin",
        title12: "Lütfen para birimini seçin",
        title13: "Lütfen transfer edilecek tutarı giriniz",
        title14: "Başarıyla gönderildi",
        table1: "Hesabı aktar",
        table2: "para birimi transferi",
        table3: "Transfer miktarı",
        table4: "hesap transferi",
        table5: "zaman",
        table6: "Aktar",
        table7: "Fon Transferi",
        table8: "Transfer",
        table9: "aktarım kaydı",
        table10: "Aktarım ayrıntıları",
        table11: "Aktarım başarılı",
        table12: "Aktarım başarısız oldu",
        table13: "Cari hesap devredilemez"
    },
    withdrawal: {
        title1: "önemli Uyarı",
        title2: "1.Arbitrajı önlemek amacıyla işlem hacmi kotaya ulaştığında para çekme başvurusunda bulunabilirsiniz.",
        title3: "2.Para çekme başvurusu, gönderimden sonraki 24 saat içinde hesaba geçecektir. Eğer para çekme işlemi beklenen para çekme süresinden sonra alınmazsa, lütfen çevrimiçi müşteri hizmetleriyle iletişime geçin.",
        title4: "3.Para çekme başvurusunu gönderdikten sonra, para çekme işlemi devam ettiği için fonlar donmuş durumdadır ve fonlar geçici olarak sistem tarafından tutulmaktadır. Bu, varlığı kaybettiğiniz veya varlıkta bir anormallik olduğu anlamına gelmez.",
        title5: "Para birimi",
        title6: "cüzdan adresi",
        title7: "Çekilen coin miktarı",
        title8: "Para çekme kaydı",
        title9: "Lütfen para birimini seçin",
        title10: "Lütfen zincir tipini seçin",
        title101: "",
        title11: "girin lütfen",
        title12: "cüzdan adresi",
        title13: "Başarıyla gönderildi",
        title14: "inceleme altında",
        title15: "İnceleme başarılı",
        title16: "Denetim hatası",
        title17: "Ödenen",
        title18: "Lütfen cüzdan adresinizi girin veya yapıştırın",
        title19: "Lütfen çekim tutarını giriniz",
        title20: "Hizmet bedeli",
        title21: "Gerçek varış",
        table1: "Para birimi",
        table2: "Çekilen coin miktarı",
        table3: "Zincir adı",
        table4: "cüzdan adresi",
        table5: "durum",
        table6: "sebep",
        table7: "başvuru zamanı",
        table8: "Madeni para çekme",
        table81: "Madeni para çekme",
        table9: "Para çekme adresi",
        table10: "Lütfen çekmek istediğiniz para birimini seçiniz",
        table11: "Lütfen girdiğinizden emin olun",
        table12: 'Adres (genellikle "0x" ile başlar)',
        table13: "Paralar çekilebilir (işlem ücreti düşülür)：",
        table14: "Para birimini seçin",
        table15: "Sorunlarla mı karşılaştınız? Anında geri bildirim",
        table16: "denge",
        table17: "Para çekme ayrıntıları",
        password: "şifre",
        passwordTips: "Lütfen şifre giriniz",
        passwordAg: "Şifreyi Onayla",
        passwordAgTips: "Lütfen şifreyi tekrar girin",
        oldPassword: "eski Şifre",
        oldPasswordTips: "Lütfen eski şifreyi girin",
        newPassword: "Yeni Şifre",
        newPasswordTips: "Lütfen yeni bir şifre girin",
        passwordNotSame: "Şifreler tutarsız",
        withdrawPasswordSet: "Para çekme şifresini ayarla",
        withdrawPasswordModify: "Para çekme şifresini değiştir",
        withdrawPassword: "Şifreyi geri çek",
        withdrawPasswordTips: "Lütfen para çekme şifresini girin",
        setWithdrawPasswordFirst: "Lütfen önce bir para çekme şifresi belirleyin",
        withdrawPasswordSetSuccess: "Kurulum başarılı",
        withdrawPasswordModifySuccess: "Başarıyla değiştirildi",
        submit: "göndermek",
    },
    customer: {
        content1: "çevrimiçi servis",
        content2: "müşteri servisi",
        content3: "Lütfen iletişim bilgilerinizi girin",
        content4: "Lütfen içeriği girin",
        content5: "Göndermek",
        content6: "Gönderim başarısız oldu, ağ bağlantısı başarısız oldu",
        content7: "resim",
        content8: "mesaj boş",
        content9: "benim payım",
        content10: "linki paylaş",
        content11: "resmi Kaydet",
        content12: "kazancım",
        content13: "Seviye açıklaması",
        content14: "Takım boyu",
        content15: "Davetiye geliri",
        content16: "Talimatları paylaş",
        content17: "üyelik seviyesi",
        content18: "Şarj miktarı şundan daha fazla:",
        content19: "Takım seviyesi",
        content20: "Takım Seviyesi ve Geliri",
        content21: "Koşulları karşılamak için",
        content22: "Dağıtım geliri",
        content23: "seviye ekibi",
        content24: "seviye, davet",
        content25: "geçerli üyeler",
        content26: "birincil gelir",
        content27: "ikincil gelir",
        content28: "Seviye 3 geliri",
    },
    standardContract: {
        increaseMargin: "marjı artır",
        increaseAmount: "miktarı artır",
        Pleaseenterthemargin: "Lütfen artırılacak teminat tutarını giriniz",
        Pleaseenterthecorrect: "Lütfen doğru para yatırma tutarını girin",
        Increasemarginsuccessfully: "Marjı başarıyla artırın",
        takeProfitPriceWrong: "Kar Fiyatını Yanlış Almak",
        stoppriceerror: "Fiyat hatasını durdur",
        thetakeprofit1: "Kâr alma fiyatı piyasa fiyatından yüksek olmalıdır",
        thetakeprofit2: "Zararı durdurma fiyatı piyasa fiyatından düşük olmalıdır",
        thetakeprofit3: "Kâr alma fiyatı piyasa fiyatından düşük olmalıdır",
        thetakeprofit4: "Zararı durdurma fiyatı piyasa fiyatından yüksek olmalıdır",
        thetakeprofit5: "Yanlış miktar",
        estimatedprofitloss: "Tahmini kar ve zarar",
        positionAmount: "Pozisyon sayısı",
        closeAmount: "Kapanış miktarı",
        whenthelatest: "Son fiyata ulaşıldığında",
        whenthelatest2: ", mevcut pozisyonu kapatmak için piyasa fiyatından kar alma emri tetiklenecektir. Beklenen kar ve zarar",
        whenthelatest3: "mevcut pozisyonu kapatmak için piyasa zararı durdurma emri tetiklenecektir. Beklenen kar ve zarar",
        contract: "sözleşme",
        ordercanceledsuccessfully: "Sipariş başarıyla iptal edildi",
        successfullyordered: "başarıyla sipariş edildi",
        positionopeningreminder: "Pozisyon açılış hatırlatıcısı",
        wrongquantity: "Yanlış miktar",
        quantitycannot: "Miktar şu miktardan büyük olamaz:",
        modificationstoploss: "Kar durdurma ve zarar durdurma değişiklikleri başarılı",
        positionclosedsuccessfully: "Pozisyon başarıyla kapatıldı",
        orderCancellation: "Sipariş iptali",
        orderCancellation2: "Siparişi iptal etmek istediğinizden emin misiniz?",
        tobeexecuted: "İdam edilecek",
        expired: "günü geçmiş",
        failed: "arızalı",
        contractTransaction: "Sürekli sözleşme",
        increase: "Arttırmak",
        openPosition: "Tam depo",
        isolatedPosition: "İzole konum",
        limitOrder: "fiyat sınırı",
        marketOrder: "Market fiyatı",
        pleaseSelectLeverage: "Lütfen kaldıracı seçin",
        pleaseEnterQuantity: "Lütfen miktarı girin",
        canOpenMore: "Açılabilecek maksimum konum",
        contractAmount: "Kontrat miktarı",
        openingFee: "Hizmet bedeli",
        currentPosition: "Konum",
        historicalPositions: "Geçmiş işlemler",
        currentCommission: "Şuan ki sipariş",
        historicalCommission: "tarihi komisyon",
        buyPrice: "Alış fiyatı",
        income: "kazanç",
        quantity: "miktar",
        marginRate: "marj oranı",
        initialMargin: "Başlangıç ​​marjı",
        estimatedPriceParity: "Zorunlu tasfiye fiyatı",
        operate: "işletmek",
        finishQuantity: "İşlem hacmi",
        averagePrice: "ortalama işlem fiyatı",
        pleaseEnterLeverage: "Lütfen kaldıracı girin",
        takeProfitAndStopLoss: "Kâr alın ve zararı durdurun",
        takeProfit: "Kar almak",
        stopLoss: "kaybı durdurmak",
        openLong: "Long",
        openShort: "Short",
        liquidation: "Konumu kapat",
        marketLquidation: "Piyasa fiyatı sabit",
        cancel: "Siparişi iptal et",
        enterBuyPrice: "Lütfen alış fiyatını giriniz",
        areYouSureLquidation: "Pozisyonu kapatacağınızdan emin misiniz?",
        confirm: "Elbette",
        enterStopWinPrice: "Lütfen kar alma fiyatını girin",
        enterStopLossPrice: "Lütfen zararı durdurma fiyatını girin",
        commissionTime: "Komisyon süresi",
        commissionPrice: "Komisyon fiyatı",
        commissionQuantity: "Toplam komisyon tutarı",
        volumeAlreadyTraded: "Tamamlanan tutar",
        areYouSureToWinOrLoss: "Kârı durdurmak ve zararı durdurmak istediğinizden emin misiniz?",
        maxQuantity: "Maksimum konum",
        saleQuantity: "Pozisyon kapalı",
        salePrice: "ortalama kapanış fiyatı",
        saleTime: "zaman",
        succeeded: "Başarılı",
        cancelled: "İptal edildi",
        piece: "açık",
        triggerPrice: "tetik fiyatı",
        setWin: "Kâr almayı ayarla",
        setLoss: "Zararı durdurmayı ayarla",
        enterWinQuantity: "Lütfen kar alma tutarını girin",
        enterLossQuantity: "Lütfen zararı durdurma tutarını girin",
        planCommission: "Komisyon planı",
        enterWinTriggerPrice: "Lütfen kar alma tetik fiyatını girin",
        enterLossTriggerPrice: "Lütfen zararı durdurma tetikleme fiyatını girin",
        insufficientQuantity: "Yetersiz miktar",
        enterTriggerPrice: "Lütfen tetik fiyatını girin",
        tips1: "Emir fiyatınız güncel fiyattan yüksektir ve doğrudan güncel piyasa fiyatı üzerinden gerçekleştirilecektir. Almak istediğinizden emin misiniz?",
        tips2: "Emir fiyatınız güncel fiyattan daha düşük ve direkt olarak güncel piyasa fiyatı üzerinden gerçekleştirilecek. Alış yaptığınızdan emin misiniz?",
        type: "tip",
        increaseQuantity: "Konumu artır",
        reduceQuantity: "Pozisyonları azaltın",
        limitCommission: "limit emri",
        tips3: "Zararı durdurma fiyatı piyasa fiyatından düşük olmalıdır",
        tips4: "Kâr alma fiyatı piyasa fiyatından yüksek olmalıdır",
        tips5: "Zararı durdurma fiyatı piyasa fiyatından yüksek olmalıdır",
        tips6: "Kâr alma fiyatı piyasa fiyatından düşük olmalıdır",
        tips7: "Zararı durdurma fiyatı piyasa fiyatından ve emir fiyatından düşük olmalıdır",
        tips8: "Kâr alma fiyatı emir fiyatından yüksek olmalıdır (piyasa fiyatından daha küçük olabilir)",
        tips9: "Zararı durdurma fiyatı piyasa fiyatından ve emir fiyatından yüksek olmalıdır",
        tips10: "Kâr alma fiyatı emir fiyatından küçük olmalıdır (piyasa fiyatından büyük olabilir)",
        accountEquity: "Hesap bakiyesi",
        unrealizedPL: "gerçekleşmemiş kar veya zarar",
        tips11: "Haklı olduğundan emin misin",
        tips12: "Market fiyatı",
        tips13: "Tüm pozisyonları kapat",
        tips14: "Bir daha hatırlatma",
        profitRate: "Kapanış getiri oranı",
        openTime: "Açılış zamanı",
        unwindTime: "Kapanış saati",
        dealTime: "İşlem süresi",
        amountClose: "Kapalı pozisyon miktarı",
        long: "birçok",
        short: 'hükümsüz',
        orderQuantity: "Sipariş Miktarı",
        entrustedMargin: "emanet edilen marj",
    },
    spotGoods: {
        spotGoods: "Flaş değişimi",
        sellPrice: "satış fiyatı",
        orderRecord: "Flaş kullanım kaydı",
        transactionTime: "İşlem süresi",
        maxBuy: "satınalınabilir",
        maxSell: "Satılık",
        purchaseQuantity: "Satın alma miktarı",
        slippage: "Kayma",
        convertTips: "%0-5 kayma ile en uygun fiyattan işlemi kapatacağız.",
        changePrice: "Güncel döviz fiyatı",
        consume: "tüketmek",
        get: "elde etmek",
        changeTips: "Kullanmak istediğinizden emin misiniz?",
        confirm: "Değişimi onayla"
    },
    news: {
        title: "haber Merkezi",
        redMore: "devamını oku",
    },
    credit: {
        credit: "kredi notu",
        creditScore: "toplam kredi puanı",
        latestEntry: "son kayıt",
        liveUpdate: "Canlı güncelleştirme",
        systemEvaluation: "Sistem değerlendirmesi",
        time: "tarih",
        name: "isim",
        reason: "sebep",
        scoreStory: "Kredi notu kaydı"
    },
    borrowing: {
        borrowing: "borç",
        diversifiedMarket: "Çeşitlendirilmiş pazarlar",
        totalSupply: "Toplam arz",
        totalBorrowings: "toplam borçlanmalar",
        tips1: "Teminatınız karşılığında borçlanma limitine kadar ödünç alabileceğiniz toplam tutardır.",
        tips2: "İstikrarlı faiz oranınız kredinizin ömrü boyunca aynı kalacaktır. Uzun vadeli tedarik ve öngörülebilirliği seven kullanıcılar için önerilir.",
        totalSupplys: "toplam arz",
        supplyAPR: "arz oranı",
        totalBorrowings: "Toplam borçlanma",
        borrowAPR: "borçlanma oranı",
        check: "Kontrol etmek",
        market: "pazar",
        availableLiquidity: "Mevcut likidite",
        currencyPrice: "güncel döviz fiyatı",
        supplyAssets: "tedarik varlıkları",
        tips3: "Not: Aşağıdaki faiz oranı sabit faiz oranı olup, arz süresi bittikten sonra anapara artı kazanç hesabınıza iade edilecektir.",
        supplyCycle: "tedarik döngüsü",
        minimumSupply: "minimum arz",
        supply: "tedarik",
        borrowedAssets: "ödünç alınan varlıklar",
        tips4: "Bilmeniz gereken önemli: Borç almak için herhangi bir teminat varlığı veya kanıt sunmanız gerekecektir.",
        tips5: "Lütfen ipotek varlık açıklamasına bakın。",
        repaymentCycle: "geri ödeme döngüsü",
        BorrowableAmount: "Mevcut kredi tutarı",
        borrow: "borç",
        accountInformation: "Hesap Bilgileri",
        walletBalance: "cüzdan bakiyesi",
        canSupply: "Mevcut",
        AmountCanBeBorrowed: "Mevcut toplam kredi tutarı",
        borrowedAmount: "Ödünç alınan miktar",
        remainingAmount: "kalan bakiye",
        getBorrowednAmount: "Kredi limiti al",
        supplyOrder: "Tedarik emri",
        borrowedOrder: "kredi emri",
        supplyAmount: "tedarik miktarı",
        expectedProfits: "Beklenen getiri",
        supplyTime: "Tedarik süresi",
        expirationTime: "Son kullanma tarihi",
        borrowingAmount: "Kredi miktarı",
        dueRepayment: "Geri Ödeme Tutarı",
        borrowingTime: "Yayınlanma zamanı",
        repaymentTime: "Geri ödeme süresi",
        repay: "geri ödeme",
        supplyCurrency: "para birimi sağlamak",
        buyNow: "Şimdi al",
        supplyRecords: "tedarik kayıtları",
        borrowRecords: "Kredi kayıtları",
        completed: "tamamlanmış",
        borrowNow: "Şimdi ödünç al",
        borrowCurrency: "Borçlanma para birimi",
        borrowMin: "en küçük",
        borrowMax: "maksimum",
        borrowRange: "Borçlanma tutarı (minimum/maksimum)",
        tips6: "Lütfen zamanında ödeyiniz, eğer vadesi geçmişse, günlük ilave tutar (anapara+faiz) tahsil edilecektir.",
        tips7: "Geç ücreti。",
        pleaseEnterBorrowAmount: "Lütfen kredi tutarını giriniz",
        interest: "Faiz",
        tips8: "Peşin ödeme yapmak istediğinizden emin misiniz?",
        borrowChannel: "Borçlanma kanalı",
        tips9: "Seni tanıyarak başlayalım",
        name: "isim",
        lastName: "soyadı",
        birthDate: "doğum tarihi",
        tips10: "Biraz daha bilgi, adresiniz nedir?",
        familyAddress: "Ev adresi (ünite numarası dahil)",
        city: "Şehir",
        country: "ulus",
        postalCode: "Posta Kodu",
        pleaseEnterYourHomeAddress: "Lütfen ev adresinizi girin",
        tips11: "Bize mali durumunuzdan bahsedin",
        tips12: "Bu bilgiyi daha sonra doğrulamamız gerekebilir, bu nedenle lütfen mümkün olduğunca doğru olmaya çalışın.",
        yourMonthlyIncome: "aylık geliriniz",
        enterYourMonthlyIncome: "Lütfen aylık gelirinizi giriniz",
        extraIncomeOptional: "Ek gelir (isteğe bağlı)",
        enterExtraIncome: "Lütfen ek gelirinizi girin",
        monthlyRentOrMortgagePayment: "Aylık kira veya ipotek ödemesi",
        enterMonthlyRent: "Lütfen aylık kira veya ipotek ödemenizi girin",
        tip13: "İpotekiniz varsa bize bildirin",
        tip14: "İpotek garantisi seçilmediği takdirde incelemeyi geçme olasılığı düşüktür.",
        isThereMortgage: "İpotek var mı?",
        selectIsThereMortgage: "Lütfen ipotek olup olmadığını seçin",
        selectMortgageType: "Lütfen ipotek türünü seçin",
        yes: "Evet",
        no: "HAYIR",
        uploadScreenshotOfTransaction: "Lütfen işlem ekran görüntülerini yükleyin",
        tip15: "İrtibatta kalalım",
        tip16: "Kredi başvurunuzla ilgili daha fazla bilgiye ihtiyaç duymamız halinde sizinle bu numaradan iletişime geçebiliriz.",
        tip17: "Onayımı okudum ve elektronik olarak imzaladım",
        tip18: "Kullanım Koşulları ve Elektronik Onay",
        tip19: "，Bu, size ürünlerimiz hakkında bilgi göndermemize izin vermenizi de içerir.",
        tip20: "Ürün ve Hizmet Kullanım Koşulları",
        tip21: "Bilgileri doldurduktan sonra lütfen sistem değerlendirmesi ve incelemesini bekleyin.",
        phoneNumber: "telefon numarası",
        enterPhoneNumber: "Lütfen telefon numaranızı girin",
        tip22: "Kullanım koşullarını ve elektronik onay formunu kabul etmek için lütfen kutuyu işaretleyin",
        inReview: "inceleme altında",
        applicationAmount: "Başvuru miktarı",
        reasonForRejection: "Reddedilme nedeni",
        reapply: "Yeniden başvur",
        applyStatus: "uygulama durumu",
        currentOrder: "şuan ki sipariş",
        interestRate: "faiz oranı"
    },
    yuebao: {
        filed1: "yatırım",
        filed2: "Çıkarmak",
        filed3: "Günlük gelir",
        filed4: "takım hızlandırma",
        filed5: "Yatırıldı",
        filed6: "Dünkü kazanç",
        filed7: "Toplam gelir",
        filed8: "Mevcut fonlar",
        filed9: "Lütfen tutarı girin",
        filed10: "Likidite madenciliği",
        filed11: "giriiş",
        field12: "Minimum satın alma fiyatı",
        field13: "Satın alabileceğiniz en fazla",
        filed14: "Abonelik",
        filed15: 'düzenli',
        filed16: 'yıllık faiz oranı',
    },
    tipsPopover: {
        title: "Bu uygulamayı yükle",
        press: "buna göre",
        and: "Ve",
        scrren: "Ana ekrana ekle",
        hasInstall: "(Yüklüyse lütfen pencereyi kapatın)",
    },
    follow: {
        title1: "Takip planı",
        follow_text1: "Sipariş Oluştur",
        follow_text2: "Sürüm geçmişi",
        follow_text3: "başlık",
        follow_text4: 'ticaret çifti',
        follow_text5: 'Satın alma süresi',
        follow_text6: 'sipariş zamanı',
        follow_text7: 'yayınlanma zamanı',
        follow_text8: 'Takipçi sayısı',
        follow_text9: 'Sipariş miktarı',
        follow_text10: 'işletmek',
        follow_text11: 'davet etmek',
        follow_text12: 'Sipariş yönünü takip edin',
        follow_text13: 'Sipariş koşullarını ayarlayın',
        follow_text14: 'Siparişleri takip etme koşulları',
        follow_text15: 'sabit miktar',
        follow_text16: 'yüzde',
        follow_text17: 'Davet edilen kişiler',
        follow_text18: 'Karşı tarafın kimliği',
        follow_text19: "Siparişi takip etmeyi onaylayın",
        follow_text20: "Sipariş tutarınız (isteğe bağlı)",
        follow_text21: "Lütfen bir başlık girin",
        follow_text22: "Lütfen bir işlem çifti seçin",
        follow_text23: "Lütfen sipariş yönünü seçin",
        follow_text24: "Lütfen satın alma süresini seçin",
        follow_text25: "Lütfen sipariş zamanını seçin",
        follow_text26: "Lütfen satın alma miktarını seçin",
        follow_text27: "Maksimum satın alma miktarı, minimum satın alma miktarından az olamaz",
        follow_text28: "Minimum katılım",
        follow_text29: "En çok satın alınanlar",
        follow_text30: "Kopyalama sırasını başarıyla oluştur",
        follow_text31: "Ticaret çifti listesi",
        follow_text32: "Siparişi zaten takip ettim",
        follow_text33: "Lütfen davetli bilgilerini girin",
        follow_text34: "Davet edildi",
        follow_text35: "beni davet etti",
        follow_text36: "Geçmiş kopyalanıyor",
        follow_text37: "Sipariş miktarı aralığı",
        follow_text38:"Lütfen sipariş kodunu girin"
    },
    followHistory: {
        title1: 'Sürüm geçmişi',
        title2: "Geçmiş kopyalanıyor",
        follow_h_text1: "Siparişin toplam tutarı",
        follow_h_text2: "Emirleri takip eden toplam kişi sayısı",
        follow_h_text3: "Sürüm sayısı",
        follow_h_text4: "kazanma oranı",
        follow_h_text5: "Emirlerin takip edilme sayısı",
        follow_h_text6: "Takip eden siparişlerden kar elde edin",
        follow_h_text7: "yön",
        follow_h_text8: "kazanç",
        follow_h_text9: "açık",
    },
    "download.description.C80C1Edd6Bee12Bc": "1.Açıklama dosyalarının indirilmesine izin ver",
    "download.description.2F5Bc180F92642B4": "2.Açıklama dosyası indirildi",
    "download.description.3C3B849F6Ccf712F": "3.Telefonunuza [Ayarlar] girin; indirilen açıklama dosyası hesap bilgilerinin altında görüntülenecektir.",
    "download.description.86Affd862985E045": "4.Açıklama dosyasını indirmek için tıklayın",
    "download.description.32832492Bfc1D95E": "5.Kurmak için tıkla",
    "home.index.04Ee893775563F25": "Piyango çekilişini bekliyorum",
    "home.index.04Ee893775563F26": "Piyango devam ediyor",
    "passwod.limit":"Şifre uzunluğu 6 karakterden büyük veya ona eşit olmalıdır",
    "finance.header.5Cbf11665B91D51D": "Bakiye Ekleme",
    "finance.index2.B1A4Be8079A937F8": "Satın Alınabilir Tutar Aralığı",
    "finance.index2.8371E53029Dc7558": "Sözleşme İhlali Ücreti",
    "finance.index2.Bf9A2C9Bf7Ecaf04": "Borçlanma oranı",
    "finance.index2.2Ad78Bbd879C4990": "Hemen Satın Al",
    "finance.index2.A3B7445Ea9D7E111": "Satın Alınamaz",
    "finance.index2.A3B7445Ea9D7E112": "Satın Alınabilir",
    "finance.index2.87701Fe9Ad8540Dc": "Toplam Satın Alınabilir Tutar / Şu Anda Satın Alınan Tutar",
    "finance.index2.652Effdf5D1Af6A2": "Tahmini Getiri Oranı",
    "finance.index2.D3C3C19De952Fc0C": "Satın Alma Tarihi",
    "finance.index2.6C4C46Cc4Da0C281": "Mevcut Tutar",
    "finance.index2.3E9A6703Abd8A3E4": "Dünkü Getiri",
    "finance.index2.596704E9869C8134": "Toplam Getiri",
    "finance.index2.0A845B549624B74B": "Yıllık Getiri Oranı",
    "finance.index2.9A7758Cad0402366": "Mevcut Durum",
    "finance.index2.9A7758Cad0402367": "Getiri Kayıtları",
    "finance.index2.8B8Ceb7610C747Eb": "Geçmiş Kayıtlar",
    "finance.index2.8B8Ceb7610C747Ec": "Yatırım Kayıtları",
    "finance.index2.0B049108D57B9Dd5": "Erken Çekme",
    "finance.index2.37Ffde1Ee1D3C8D4": "Erken Çekilen",
    "finance.index2.12F6B830Aee90Efb": "Vade Sonu",
    "finance.index2.40E1944D8Cafbdad": "Sahip Olunan Tutar",
    "finance.index2.9815C4F248B624F5": "Satın Alma Tarihi",
    "finance.index2.46F7Be1133B3E2C6": "Bitiş Tarihi",
    "finance.index2.Fc8643Aa7Babcce8": "Getiri",
    "finance.index2.1F2B02E97721B997": "Erken Çekildi mi?",
    "finance.index2.14E543A74595Efe8": "Başvuru Sürecinde",
    "finance.index2.14E543A74595Efe9": "Devam Eden",
    "finance.index2.14E543A74595Efe0": "Tamamlandı",
    "finance.index2.8E29Fbba37286B63": "Mentör Adı",
    "finance.index2.D736C17Df71Bcdb2": "Başvuru Tutarı",
    "finance.index2.F38884Ed4410D9F6": "Başvuru Onay Tutarı",
    "finance.index2.E3347Eb6F76Eda1C": "Elde Edilen Getiri",
    "finance.index2.0Fc0070Cb4E9F5A8": "Yatırım Zamanı",
    "finance.index2.8Efd11Be6D9F43Df": "Getiri Başlangıç Zamanı",
    "finance.index2.16658A855F07D171": "Tutar",
    "finance.index2.184333C81Babf2F1": "Tip",
    "finance.index2.15Cba911299D4Afd": "Hemen Satın Al",
    "finance.index2.Da1Cdb155Ae381Cd": "Çekilecek Tutar",
    "finance.index2.15Efec8F145F2608": "Mevcut Tutar (USDT) : ",
    "finance.index2.159253C05C270D46": "Sahip Olunan Tutar (USDT) : ",
    "finance.index2.Caab3A4Ba941E0E3": "Erken Çekme Ücreti (USDT) : ",
    "finance.index2.Fb5Fc50Cf3716723": "Satın Alabilir",
    "finance.index2.5Dcb4Ee5C7F1F4E1": "Tutar Girin",
    "finance.index2.5886C88906Cc4491": "Her Yatırımınızı En İyi Şekilde Hizmet Veren Yıldızlar Takımı",
    "finance.index2.5886C88906Cc4492": "Sabit Getiri, Piyasa Dalgalanmalarında Rahatlıkla Kazanç Sağlama",
    "finance.index2.F5Af24Dbad5837Ea": "Satın Alma Başarılı",
    "finance.index2.Be15Df7F1D76F9B2": "Yatırılan Miktar",
    "finance.index2.Fc57951B528F3Dd3": "Ödünç Verilebilir",
    "finance.index2.3F91F76109Fdbdeb": "Ödünç Verilen",
    "finance.index2.F68600F93Fe31213": "Ödünç Alma",
    "finance.index2.494E47D4025Da8E6": "Ödeme",
    "finance.index2.27F6657Ebf2025E3": "Ödünç Alınan Miktar",
    "finance.index2.27F6657Ebf2025E4": "Ödeme Miktarı",
    "finance.index2.631Fc4Ce8Aeee66F": "Ödünç Alma Onayı",
    "finance.index2.631Fc4Ce8Aeee66G": "Ödeme Onayı",
    "time.text1":"Başlangıç Tarihi",
    "finance.index2.631Fc4Ce8Aeee66H": "Teyit edilecek",
}
